import {
    // Tags
    BRIDGES,
    COLLECTIBLES,
    DAPPS,
    DEFI,
    GAMEFI,
    DEV_TOOLING,
    INFRA,
    LAUNCHPAD,
    LENDING,
    MARKETPLACES,
    MEMECOINS,
    METAVERSE,
    NFT,
    NATIVE_NFT,
    FORK_NFT,
    P2E,
    PAYMENTS,
    SERVICES,
    SOCIAL,
    STABLECOINS,
    UTILITIES,
    EXCHANGES,
    WALLET,
    ORACLE,
    // Chains
    ETC,
    ETF,
    ETHW,
    // LINKS
    DAPP,
    DISCORD,
    FACEBOOK,
    GITHUB,
    INSTAGRAM,
    MEDIUM,
    TELEGRAM,
    TWITTER,
    WEBSITE,
} from './metaData.js';

const DATA = [
    {
        name: 'AavePoW',
        tags: [DEFI, INFRA, EXCHANGES],
        description: "AavePoW is a decentralized non-custodial liquidity protocol where users can participate as depositors or borrowers.",
        links: {
            [WEBSITE]: 'https://aavepow.com/',
            [DAPP]: 'https://aavepow.com/',
            [TWITTER]: 'https://twitter.com/aave_pow',
            [TELEGRAM]: 'https://t.me/aave_pow',
        },
        image: 'https://i.postimg.cc/3rzGPKBq/aave-pow.png',
        chains: [ETHW],
    },
    /* 
    {
        name: 'AlienExchange',
        tags: [EXCHANGES],
        description: "Alienexchange on #EthereumFair and #EthereumPoW Bring the perfect experience to users! We bring Exchange+Farm+Lock+LaunchuPad!",
        links: {
            [WEBSITE]: 'https://alienexchange.org/',
            [DAPP]: 'https://ethw.alienexchange.org/',
            [TWITTER]: 'https://twitter.com/Alien_Exchanges',
            [TELEGRAM]: 'https://t.me/alienexchange_ethw',
        },
        image: 'https://i.postimg.cc/TPGXvjwM/LOGO1280-1280-Philip-Charles.png',
        chains: [ETHW],
    },
    */
    {
        name: 'AirCoinSwap',
        tags: [DAPPS, EXCHANGES],
        description: "AirCoinSwap supports more than 900 kinds of tokens to be exchanged,it originates from Uniswap V3, which automatically selects the best path for exchange.",
        links: {
            [DAPP]: 'https://aircoinswap.xyz/',
            [TWITTER]: 'https://twitter.com/aircoinswap',
            [GITHUB]: 'https://github.com/greyireland',
        },
        image: 'https://pbs.twimg.com/profile_images/1570611914551742466/_AcpskwQ_400x400.png',
        paragraphs: [
            "We are the largest market maker of BSC. We have top arbitrage experience and DEX trading experience.",
            "Use AirCoinSwap to become the most professional arbitrageur at the fastest speed.",
        ],
        chains: [ETHW],
    },
    {
        name: 'amihan.ir',
        tags: [DEV_TOOLING],
        description: "Dev Tools",
        links: {
            [WEBSITE]: 'https://amihan.ir/',
        },
        image: 'https://amihan.ir/amihan-logo.png',
        paragraphs: [
            "Hi please read it",
            "why you doesn’t speak by gpu companies,pools and exchange systems to help for growing mineable coin? even cartels and reach people can have it,it is not time to development and coding,if lots of gpu farms like us switche off and sell gpus all the market will fall down,cause miners are only people that believe to coin and have most transactions.",
        ],
        chains: [ETHW],
    },
    {
        name: 'AMPLW',
        tags: [STABLECOINS, DEFI],
        description: "AMPLW is the fork project of AMPL, It is the first algorithmic stablecoin of the ethw ecosystem. It can currently be traded on UNIWSWAP.",
        links: {
            [WEBSITE]: 'https://luckyegg.ethwlottery.com/',
            [DAPP]: 'https://luckyegg.ethwlottery.com/',
            [TWITTER]: 'https://twitter.com/ethwlottery',
            [TELEGRAM]: 'https://t.me/ETHWLottery',
        },
        image: 'https://i.postimg.cc/4ytCpR9H/photo1666237333.jpg',
        paragraphs: [
            "AMPLW is the fork project of AMPL, It is the first algorithmic stablecoin of the ethw ecosystem. It can currently be traded on UNIWSWAP.",
            "Amplw, however, differs from other stablecoins in its method of maintaining price stability.",
            "Instead of relying on deposits or issuing and redeeming debt, the software programmatically adjusts the supply of its AMPLW cryptocurrency every 1 hours in a process called “rebasing.”",
            "If demand for AMPLW tokens is high, and each AMPLW token exceeds $1, the supply will increase. If demand is low, supply will decrease.",
        ],
        chains: [ETHW],
    },
    {
        name: 'Antlink',
        tags: [DEFI, ORACLE],
        description: "Antlink is the first decentralized oracle network on the ETHW chain to open up the interaction between blockchain and real world.",
        links: {
            [WEBSITE]: 'https://antlink.io/',
            [DAPP]: 'https://data.antlink.io/',
            [TWITTER]: 'https://twitter.com/AntlinkPoW',
            [DISCORD]: 'https://discord.gg/BJbYk5Vg3T',
        },
        image: 'https://i.postimg.cc/jjv53HnK/Qim3-TZp-400x400.jpg',
        isVerified: false,
        chains: [ETHW],
        paragraphs: [
            'Open up the interaction between blockchain and the real world.',
            'Antlink decentralized oracle networks provide tamper-proof inputs, outputs, and computations to support advanced smart contracts on any blockchain.',
        ],
    },
    {
        name: 'Baby XEN',
        tags: [MEMECOINS],
        description: "Cryptocurrency For Apers!",
        links: {
            [WEBSITE]: 'https://linktr.ee/babyxencrypto',
            [DAPP]: 'https://linktr.ee/babyxencrypto',
            [TWITTER]: 'https://twitter.com/babyxencrypto0x',
            [TELEGRAM]: 'https://t.me/babyxencrypto0x',
        },
        image: 'https://i.postimg.cc/0ysVqPG6/logo4-Baby-XEN-Crypto.png',
        isVerified: false,
        chains: [ETHW],
        paragraphs: [
            'Baby XEN smart contract charges 8% pays out reflections in the XEN Crypto (XEN), with 4% distributed to Marketing Fund and 2% going to Baby XEN liquidity pool.',
        ],
    },
    {
        name: 'Beatles',
        tags: [NATIVE_NFT],
        description: "The first NFT Beatles launched on ETHW chain.",
        links: {
            [WEBSITE]: 'https://sikalang.com/',
            [TWITTER]: 'https://twitter.com/BeatlesPOW',
            [DISCORD]: 'http://discord.com/invite/pT4fQsp4',
        },
        image: 'https://pbs.twimg.com/profile_images/1571755895918366721/G1PwbWfJ_400x400.jpg',
        isVerified: true,
        chains: [ETHW],
    },
    {
        name: 'BitKeep',
        tags: [EXCHANGES, DEFI, NFT, WALLET],
        description: 'BitKeep, the top decentralized multi-chain crypto wallet in Asia, integrates Wallet, Swap, NFT Market, DApp, and Launchpad in a single app.',
        links: {
            [WEBSITE]: 'https://bitkeep.io/',
            [TWITTER]: 'https://twitter.com/BitKeepOS',
            [DISCORD]: 'https://discord.com/invite/qYTatUzNjM',
            [GITHUB]: 'https://github.com/bitkeepwallet/',
            [FACEBOOK]: 'https://www.facebook.com/BitKeep',
            [MEDIUM]: 'https://bitkeepblog.medium.com/',
            [TELEGRAM]: 'https://t.me/BitKeep_Official',
        },
        image: 'https://pbs.twimg.com/profile_images/1533351226532069377/qUQ-I2gF_400x400.jpg',
        paragraphs: [
            "BitKeep, the top decentralized multi-chain crypto wallet in Asia, integrates Wallet, Swap, NFT Market, DApp, and Launchpad in a single app. Our mission is to build the world's largest decentralized Web3.0 portal.",
            "Founded in Singapore in May 2018, BitKeep Global Inc. now serves nearly 6 million global users worldwide, covering nearly 168 countries in North America, Europe, and Asia.",
            "BitKeep 作为亚洲 Top1 的去中心化多链数字钱包，产品集「钱包」 「BitKeep Swap」「NFT 市场」「DApp 浏览器」「Launchpad」五大功能为一体，致力 于打造全球最大的去中心化 Web3.0 入口。",
            "BitKeep Global Inc. 于 2018 年 5 月成立于新加坡，全球累计用户近 600 万， 覆盖北美、欧洲、日韩、中国、非洲、东南亚等 168 个国家和地区。",
            "最新轮融资由 Dragonfly 领投, 高榕资本, Foresight Venture, A&T Captial, Sincere Truth, 币信资本, SevenX Venture 跟投。",
            "아시아 최고의 탈중앙 멀티체인 암호화폐 지갑인 비트킵은 지갑, 스왑, NFT 마켓, 디 앱 및 디스커버를 하나의 앱에서 지원합니다.",
            "비트킵은 목표는 세계 최대의 탈중앙 웹 3.0 포털을 구축하는 것입니다.",
            "2018 년 5 월 싱가포르에서 설립된 비트킵 글로벌은 현재 전 세계적으로 600 만 명 의 글로벌 사용자를 보유하고 있으며, 북미, 유럽 및 아시아에서 168여개 국에 서비스 를 지원하고 있습니다.",
            "비트킵은 최근 드래곤플라이가 주도한 펀딩에 이어 가오롱 캐피털, 포어사이트 벤처, 신시어 트루스, 빅신 캐피털, 세븐X 벤처 등의 투자를 유치했습니다.",
        ],
        chains: [ETF, ETHW, ETC],
    },
    {
        name: 'Blesstiger',
        tags: [NFT],
        description: "PFP&Pass NFT project. NFTs automated trading platform.First NFTs can dig ETHW.Pioneering the Tiger Cave model.",
        links: {
            [WEBSITE]: 'https://blesstiger.com/',
            [TWITTER]: 'https://twitter.com/blesstiger',
            [DISCORD]: 'https://discord.gg/blesstiger',
        },
        image: 'https://i.postimg.cc/KckNwpKV/LOGO540x540-blesstigerlogo-Meta-Punks.png',
        isVerified: false,
        chains: [ETHW],
        paragraphs: [
            "Welcome to the BlessTiger project.",
            "BlessTiger pioneered the Tiger-cave model in the WEB3 field, which will provide a platform for automated trading and asset management for NFTs assets. It mainly includes three modules: Tiger-cave, automatic trading, and data analysis. The original intention of the platform is to provide long-term value to NFTs investors.",
            "We see that the field of WEB3 and NFTs is still a blue ocean, which is worth investing in. BlessTiger's philosophy is to help everyone make money together. We are well aware that the majority of NFTs investors are tired of the chasing and Fomo sentiment of various projects. Various short-term trading tools make people unable to sleep. Are you going to endure it?",
            "With us, things become very simple, you only need to mark the items you are concerned about on the platform, the system will help you automatically bid below the floor price, predict when the market is rising, and then automatically according to the preset rules Get on the shelves, monetize quickly, and the exciting thing is that these don’t require human intervention.BlessTiger also creates passive income earning opportunities for holders.",
            "What is the value of most NFT projects now? Is it the price of watching small pictures on opensea every day? Or rely on the continuous issuance of sub-projects to maintain the popularity and form a Ponzi scheme? In the end, there is no escape from the death spiral. Looking at the metaverse again, it doesn't seem much better, the vision of these projects is to make a game, like Otherside. Is the metaverse just a few games? Therefore, we firmly believe that the value of NFTs must come from valuable and unique application scenarios, and the continuous input of external value allows holders to truly participate and generate money-making opportunities. Definitely not to create unattainable circles, let alone wealth on paper.",
            "When you hold BlessTiger series NFT, you will have a commercial license, passive income opportunity, and software platform empowerment at the same time. In the future, we will take you to capture the development opportunities of WEB3 and keep you at the forefront.",
        ],
    },
    {
        name: 'Chainge Finance',
        tags: [DEFI, INFRA, EXCHANGES, WALLET],
        description: "The most liquid aggregated DEX Powered by cross-chain magic.",
        links: {
            [WEBSITE]: 'https://www.chainge.finance/',
            [TWITTER]: 'https://twitter.com/FinanceChainge',
            [GITHUB]: 'https://github.com/ChaingeFinance',
            [TELEGRAM]: 'https://t.me/chaingefinance',
            [FACEBOOK]: 'https://www.facebook.com/chainge.finance',
            [MEDIUM]: 'https://chainge-finance.medium.com/',
        },
        image: 'https://i.postimg.cc/4xPFHsVY/no-tagline-on-dark-Wizard-Sun.png',
        paragraphs: [
            "Chainge Finance is main goal revolves around full financial independency and decentralization. Powered by Fusion DCRM technology, this one of a kind digital finance app engulfs all of the features that users need in order to become their own digital bank and rid themselves of tedious traditional financial processes. From stealth cross chain transactions, escrow smart contracts & decentralized trading in the Future DEX and Options DEX.",
            "Chainge Finance has recently become the leader in the cross-chain/ interoperabity sector and stands as the most liquid cross-chain aggregated DEX on the market with 70bn+ in aggregated liquidity.",
        ],
        chains: [ETHW],
    },
    {
        name: 'BoilingSea',
        tags: [NFT],
        description: "OpenSea fork",
        links: {
            [WEBSITE]: 'http://boilingsea.com/',
        },
        image: 'http://boilingsea.com/assets/images/ocean.jpg',
        chains: [ETHW, ETF],
    },
    {
        name: 'BridgeTech',
        tags: [INFRA],
        description: "The official ETHW Bridge, which helps to bring TVL and new users to the ecosystem",
        links: {
            [WEBSITE]: 'https://www.bridgetech.network',
            [DAPP]: 'https://app.bridgetech.network/bridge',
        },
        image: 'https://i.postimg.cc/xT9QbNF2/bridgetech-Jenny-Jiang.jpg',
        chains: [ETHW, ETF],
    },
    {
        name: 'CakeWSwap',
        tags: [EXCHANGES, DEFI],
        description: "CakeWSwap is the most advanced Decentralized Exchange on the newly founded Ethereum PoW Chain, striving for true decentralization of the blockchain. The DEX boasts a brand new interface designed in house by the team, and plenty of original features to improve the userbase's experience and aid tokenomics.",
        links: {
            [WEBSITE]: 'https://cakewswap.finance/',
            [DAPP]: 'https://cakewswap.finance/',
            [TWITTER]: 'https://twitter.com/cakewswap',
            [TELEGRAM]: 'https://t.me/cakewswap',
            [MEDIUM]: 'https://medium.com/@cakewswap',
            [GITHUB]: 'https://github.com/cakewswap',
        },
        image: 'https://cakewswap.finance/images/logo.png',
        paragraphs: [
            "Interact directly with the existing uniswap contracts and liquidity. Yield farming with POW rewards. Stake POW tokens to receive a share of the dex trading fees.",
        ],
        chains: [ETHW],
    },
    {
        name: 'ClassZZ',
        tags: [DEFI, NFT, INFRA, EXCHANGES, UTILITIES, DEV_TOOLING],
        description: "The world's first native token cross-chain protocol.",
        links: {
            [WEBSITE]: 'https://classzz.com/',
            [TWITTER]: 'https://twitter.com/class_zz',
            [GITHUB]: 'https://github.com/classzz',
            [TELEGRAM]: 'https://t.me/classzzen',
        },
        image: 'https://pbs.twimg.com/profile_images/1370649319628435456/TG_WNTCd_400x400.jpg',
        paragraphs: [
            "Through ClassZZ main net and the protocol it uses - Te Waka protocol, native tokens are exchanged. Mapped tokens are unable to participate in the DeFi activities, making them less attractive to users. Thus, native tokens are needed to participate and trade. Exchanges using native tokens are straightforward rather than indirect through centralized exchange services.",
        ],
        chains: [ETHW, ETC, ETF],
    },
    {
        name: 'CompuMar',
        tags: [UTILITIES],
        description: "CompuMar is a communication protocol that provides vendors with API Rest Full.",
        links: {
            [WEBSITE]: 'https://compumarvillarrica.com/',
            [DAPP]: 'https://mega.nz/file/WjAxjYLY#UCJqA8Ke9Lit08M13PMrdyYiE-4r-BorqYhSMhSiJMQ',
            [TWITTER]: 'https://twitter.com/Satoshi04308331',
            [FACEBOOK]: 'https://www.facebook.com/CompuMar2022',
            [GITHUB]: 'https://github.com/compumar/CompuMar',
            [TELEGRAM]: 'https://t.me/compumartoken',
        },
        image: 'https://pbs.twimg.com/profile_images/1530422268156952576/3Rs3IH8G_400x400.jpg',
        paragraphs: [
            "CompuMar allows businesses to receive payments from E-wallets in the most popular stores worldwide. Also, this payment methodology supports such payment elements as PO and QR.",
            "What’s the MAR token?",
            "MAR is token serving as a means of payment inside CompuMar’s solution. So, users could obtain goods and services through the conventional markets. The developers want to open the crypto world to conventional commerce through secure methods. Apart from the above, the team tries to simplify the process with the help of most solid electronic currencies.",
        ],
        chains: [ETHW],
    },
    {
        name: 'Crazy Snaili',
        tags: [NFT, NATIVE_NFT],
        description: "Crazy Snaili Space Club.",
        links: {
            [WEBSITE]: 'https://www.nswap.link/collection/0x20255bDe9AF78c3A1ef3c1A5ca46AD19671AA9fA',
            [TWITTER]: 'https://twitter.com/Nswapcom',
            // [DISCORD]: 'https://discord.gg/ZeqkZedUv5',
        },
        image: 'https://i.postimg.cc/xTtv96bN/cuserslenovodownloads3111dfa5a3cfc1b9638a3ea341d4e87a.png',
        isVerified: true,
        paragraphs: [
            // "Crypto Cartridge Games are bringing game copy ownership back to the players with unique collectible game cartridge NFTs with variorios rarities. Every NFT is a license to a copy of a fully finished game you can play as much as you want. After you are done playing, you can either keep the cartridge and the game as a rare collectible, or sell it for others to enjoy.",
        ],
        chains: [ETHW],
    },
    {
        name: 'Crypto Cartrige Games',
        tags: [NFT, GAMEFI],
        description: "NFT RPG Game with Premium Collectible NFT Game Cartridges On Blockchain.",
        links: {
            [WEBSITE]: 'https://www.cryptocartridge.games/',
            [TWITTER]: 'https://twitter.com/CartridgeGame',
            [DISCORD]: 'https://discord.gg/ZeqkZedUv5',
        },
        image: 'https://pbs.twimg.com/profile_images/1475865655144599556/-rkZHLYQ_400x400.jpg',
        paragraphs: [
            "Crypto Cartridge Games are bringing game copy ownership back to the players with unique collectible game cartridge NFTs with variorios rarities. Every NFT is a license to a copy of a fully finished game you can play as much as you want. After you are done playing, you can either keep the cartridge and the game as a rare collectible, or sell it for others to enjoy.",
        ],
        chains: [ETHW],
    },
    {
        name: 'DefiEdge',
        tags: [DEFI],
        description: "DefiEdge is liquidity management platform built on top of Uniswap V3. A fund/asset manager can launch a strategy to manage his personal or user's funds, earning the LP fees.",
        links: {
            [WEBSITE]: 'https://defiedge.io',
            [DAPP]: 'https://app.defiedge.io/',
            [TWITTER]: 'https://twitter.com/DefiEdge',
            [DISCORD]: 'https://discord.com/invite/fRc6XxhfBq',
            [GITHUB]: 'https://github.com/defiedge/',
        },
        image: 'https://pbs.twimg.com/profile_images/1448590594859622408/IzjQ1Cbt_400x400.jpg',
        paragraphs: [
            "DefiEdge is liquidity management platform built on top of Uniswap V3. A fund/asset manager can launch a strategy to manage his personal or user's funds, earning the LP fees.",
            "The smart contracts allows anyone to be an strategy manager and earn performance and management fee for managing other's liquidity. Everytime user deposits the funds to the DefiEdge strategy, he gets the share tokens as liquidity representation.",
            "DefiEdge has following major components",
            "Share Tokens - Everytime the user deposits funds into specific strategy, strategy will mint the shares proportional to the liquidity added by the user. The starting price of the share token would be $100. DefiEdge uses Uniswap TWAP for calculating the share price.",
            "Swap - Swap between tokens in the pool using 1inch.",
            "Rebalance - The liquidity can be rebalanced to new ticks using one click",
            "Hold - If the market is volatile and the manager is not able to make the decision, DefiEdge lets the manager hold the funds into the contract.",
            "Performance Fees - Manager on DefiEdge can charge performance fees. The performance fees are debited from the fees earned in the Uniswap V3 pool of the users assets. A small portion of perfomance fees go to the protocol if the protocol fee is enabled.",
            "Management Fees - The smart contracts also allows the managers to take upfront fees. A portion of it will also go the the protocol if the protocol fees are enabled.",
        ],
        chains: [ETHW],
    },
    {
        name: 'DID Wallet',
        tags: [INFRA, WALLET],
        description: 'DID Wallet is a state-of-the-art Decentralized Identity and crypto wallet.',
        links: {
            [WEBSITE]: 'https://www.didwallet.io/',
            [TWITTER]: 'https://twitter.com/did_wallet',
            [GITHUB]: 'https://github.com/ArcBlock',
        },
        image: 'https://pbs.twimg.com/profile_images/1503136943634366465/XhYeQoic_400x400.jpg',
        paragraphs: [
            'Multi Asset, Multi Chain, All in one! DID Wallet is a state-of-the-art Decentralized Identity and crypto wallet.',
            '1. Simultaneously connect to multiple different blockchains or Layer 2 networks, easily manage multi-chain, multi-account and cross-chain cryptos and NFT all at once.',
            '2. From decentralized exchanges, cross-chain bridges to various Web 3 applications, one wallet rule them all.',
            '3. Connect with Web 3 applications from different blockchain ecosystem with multiple protocols.',
        ],
        chains: [ETHW, ETC],
    },
    {
        name: 'DogePoW',
        tags: [DEFI],
        description: 'DogePoW The First Doge  & Liquidity Locker Service on ETHW Chain, Dogepow only grow and accomplish its mission with the Army! No matter the size of the portfolio. Spread the word on social media platforms, answer questions, help people. This our Mission!',
        links: {
            [WEBSITE]: 'https://dogepow.com/',
            [TWITTER]: 'https://twitter.com/DogePOWethpow',
            [GITHUB]: 'https://github.com/DogePoW',
            [TELEGRAM]: 'https://t.me/dogepow',
        },
        image: 'https://i.postimg.cc/PNGRh5Jp/dogew-doge-pow.jpg',
        paragraphs: [
            'Details about our project :',
            '1. DogePow | COMMUNITY DRIVEN',
            '2. DogePow | BUYBACK & BURNED MECHANISM',
            '3. DogePow | LOCKER SERVICE',
            '4. DOgePow | 2D mini Game (Coming Soon)',
            'information has been submitted on the website',
        ],
        chains: [ETHW],
    },
    {
        name: 'EFWC',
        tags: [GAMEFI, NFT],
        description: 'Ethw FIFA World Cup (EFWC) is the first paradise for sports enthusiasts, a Web 3.0 betting platform, and the first FIFA World Cup quiz project on the ETHW chain.',
        links: {
            [WEBSITE]: 'https://efwc.xyz/',
            [TWITTER]: 'https://twitter.com/EFWC2022',
            [MEDIUM]: 'https://medium.com/@EFWC2022',
            [TELEGRAM]: 'https://t.me/EFWC2022',
            [DISCORD]: 'https://discord.gg/vD62S2wJA5',
        },
        image: 'https://i.postimg.cc/wxFP18jr/logo-Joey.png',
        chains: [ETHW],
    },
    {
        name: 'ENVELOP',
        tags: [DEFI, GAMEFI, NFT],
        description: 'Flexible cross-chain tool set to provide any NFT with new functionality: economic set-up, on-chain royalties, rental mechanism, time/value/event-locks, protection of devaluation and anti-fraud system',
        links: {
            [WEBSITE]: 'https://envelop.is/',
            [DAPP]: 'https://app.envelop.is',
            [TWITTER]: 'https://twitter.com/Envelop_project',
            [GITHUB]: 'https://github.com/niftsy/niftsysmarts',
            [TELEGRAM]: 'https://t.me/envelop_en',
            [MEDIUM]: 'https://blog.envelop.is/',
        },
        image: 'https://i.postimg.cc/dDMcRkSK/ENVELOP-Dmitry-Demeshko.png',
        // paragraphs: [
        //     'Details about our project :',
        //     '1. DogePow | COMMUNITY DRIVEN',
        //     '2. DogePow | BUYBACK & BURNED MECHANISM',
        //     '3. DogePow | LOCKER SERVICE',
        //     '4. DOgePow | 2D mini Game (Coming Soon)',
        //     'information has been submitted on the website',
        // ],
        chains: [ETHW, ETC],
    },
    {
        name: 'EthereumPoW',
        tags: [INFRA],
        description: 'The Original Ethereum Blockchain powered by Proof of Work.',
        links: {
            [WEBSITE]: 'https://ethereumpow.org/',
            [TWITTER]: 'https://twitter.com/EthereumPoW',
            [DISCORD]: 'https://discord.gg/apcxzJdZaU',
            [TELEGRAM]: 'https://t.me/ethereumpow_official',
            [MEDIUM]: 'https://medium.com/@ETHW',
            [GITHUB]: 'https://github.com/ethereumpow',
        },
        image: 'https://ethereumpow.org/images/logo-clear.png',
        chains: [ETHW],
        isVerified: true,
    },
    {
        name: 'ETC Swap',
        tags: [EXCHANGES, DEFI],
        description: 'ETC Swap is a decentralized cryptocurrency exchange where users acquire digital assets without an intermediary.',
        links: {
            [DAPP]: 'https://swap.ethereumclassic.com',
            [TWITTER]: 'https://twitter.com/EthClassicDAO',
            [GITHUB]: 'https://github.com/etcswap',
            [DISCORD]: 'https://ethereumclassic.org/discord',
        },
        image: 'https://ethereumclassic.org/static/b4107087d99c8cef9bf64e67f2722d47/3f9a3/etcswap.webp',
        paragraphs: [
            'ETC Swap is a decentralized cryptocurrency exchange where users acquire digital assets without an intermediary.',
        ],
        chains: [ETC],
    },
    {
        name: 'EthwSwap',
        tags: [DEFI, EXCHANGES],
        description: "EthwSwap is a DEX allowing users to do swap transactions, in phase 1, we will be supporting transactions between ETHW and other mainstream assets like USDT, USDC.",
        links: {
            [WEBSITE]: 'https://ethwswap.org',
            [TWITTER]: 'https://twitter.com/EthwSwap',
            [DISCORD]: 'https://discord.com/invite/ZC4KykPamV',
            [TELEGRAM]: 'https://t.me/ethwswap_en',
        },
        image: 'https://pbs.twimg.com/profile_images/1569940098028040192/vfPAqQwB_400x400.jpg',
        paragraphs: [
            "A Dex where you can swap forked tokens(e.g USDT) of EthereumPoW for ETHW easily&quickly.",
            "Auto arbitrage after swapping,  use flashloan to do arbitrage between different Dexes automatically and get as many ETHW as possible for you.",
            "All in one click.",
        ],
        chains: [ETHW],
    },
    {
        name: 'EthereumFair',
        tags: [DEFI, NFT, INFRA, UTILITIES, DEV_TOOLING],
        description: 'Ethereum Fair, we want to keep POW, anyone can participate without restrictions, the Ethereum Foundation is moving to PoS fork, we will keep the original chain.',
        links: {
            [TWITTER]: 'https://twitter.com/EthereumFair',
            [GITHUB]: 'https://github.com/ethereumfair',
        },
        image: 'https://pbs.twimg.com/profile_images/1554696103869947904/6bogWfb8_400x400.jpg',
        paragraphs: [
            'Mature and stable technology: The ClassZZ technical community dominates the fork, and the ClassZZ public chain PoW technology has been successfully operated for 3 years. The current technical research and development team includes math experts, chip experts and developers who have been in the industry for more than six years.',
            'Strong community consensus: a technical community with a strong PoW consensus to ensure the rapid precipitation of native users and the long-term vitality of the project.',
            'Self-contained traffic: The Ethereum Fair testnet has been launched at present, and it is also the first technical team in the world to release the Ethereum fork testnet, which has attracted the attention of global users.',
            'Miner friendly: The ETF mining difficulty is changed to the default minimum difficulty.',
            'Ecological reserves: The current wallets, communities, top ten exchanges, and ecological R&D teams are gradually connected and improved. The first batch of testnet ecological projects will also be launched at the end of August, including infrastructure such as Dex, oracles, lending, and graph.',
        ],
        chains: [ETF],
    },
    {
        name: 'Ethereum POW Laboratory ',
        tags: [DEFI, UTILITIES],
        description: 'POWLabs is a platform that provides single staking program with multiple tokens on Ethereum POW based network with high APR',
        links: {
            [WEBSITE]: 'https://powlabs.pw/',
            [DAPP]: 'https://laboratory.powlabs.pw/',
            [TWITTER]: 'https://twitter.com/POWLabs_',
            [TELEGRAM]: 'https://t.me/POWLabs',
        },
        image: 'https://i.postimg.cc/dQZ4Fzfp/Photo-1664304363103-Charlos-juremmy.png',
        paragraphs: [
            'POWLabs is a single staking platform on the Ethereum PoW network. with POWLabs you can single stake a token based on the Ethereum PoW network. POWLaps has a different staking APR for each Token, but we can be sure that the APR can satisfy your investment.',
            'POWLabs is  safe and easy to use',
        ],
        chains: [ETHW],
    },
    {
        name: 'FBBank',
        tags: [DEFI],
        description: "Decentralization Crypto Fund, the financial organization of the future world!",
        links: {
            [WEBSITE]: 'https://fbbank.cc/',
            [TWITTER]: 'https://twitter.com/FBBank_cc',
            [GITHUB]: 'https://github.com/cubeforex/FBBank',
            [MEDIUM]: 'https://medium.com/@FBBank',
            [TELEGRAM]: 'http://t.me/FBBank_cn',
        },
        image: 'https://pbs.twimg.com/profile_images/1516043418698682376/vLUHoB3G_400x400.png',
        paragraphs: [
            "FBBank is a strong community with tens of thousands of followers, and aimed to build complete infrastructure.",
        ],
        chains: [ETHW],
    },
    {
        name: 'GCA DAO',
        tags: [NFT],
        description: 'A project that are generating all kinds of art value and link on blockchain.',
        links: {
            [DISCORD]: 'https://discord.gg/AUS2aygc68',
            [MEDIUM]: 'https://medium.com/@GlobalCryptoArt',
            [TWITTER]: 'https://twitter.com/GCA_DAO',
            [WEBSITE]: 'https://www.globalcryptoart.org',
         
        },
        image: 'https://i.postimg.cc/YCVyNXwV/gcadao-logo.png',
        // paragraphs: [
        //     "With the combination of socialfi and gamefi, LikeNetwork aims to drive millions of people to the virtual digitization of social networking and the effective precision of social networking, making it easier to connect the public to Web 3.0, while relying on Socialfi to build a lasting platform to cultivate User-generated Web 3.0 content.",
        // ],
        chains: [ETHW, ETC],
    },
    {
        name: 'HipPow Swap',
        tags: [EXCHANGES],
        description: "We are a dex on the EthPow network bringing farms and liquidity to the mainnet.",
        links: {
            [DAPP]: 'https://hippowswap.com/#/swap',
            [TWITTER]: 'https://twitter.com/HipPoWSwap',
            [GITHUB]: 'https://github.com/hatmonke/HipPoW',
        },
        image: 'https://pbs.twimg.com/profile_images/1570860124238905345/YGL2cD12_400x400.jpg',
        paragraphs: [
            "We are an established team who has been heavily involved in the crypto community for years. We have implemented dexs, farms, worked with big players, and invested ourselves as well as our time into the cryptospace.",
            "This project will be established on the EthPow mainnet while forward thinking into how to bring more liquidity from EthPos to Pow and have a foundation with the disenfranchised miners. We will be providing incentives for all types of liquidity while maintaining low fees given to majority of lp holders. While establishing ourselves on mainnets such as Avax, Polygon, and dogechain to name a few.",
        ],
        chains: [ETHW],
    },
    {
        name: 'Kcalose',
        tags: [SOCIAL, NFT, GAMEFI],
        description: 'Kcalose is a Web 3.0 dApp built on ETHW chain with the vision of enabling the interoperability of blockchain technology and traditional fitness ecosystems – all while promoting advance fitness standards and rewarding fitness enthusiasts from all over the world.',
        links: {
            [WEBSITE]: 'https://kcalose.com',
            [TWITTER]: 'https://twitter.com/kcalose',
            [MEDIUM]: 'https://kcalose.medium.com',
            [TELEGRAM]: 'https://t.me/kcalose',
        },
        image: 'https://i.postimg.cc/g0PYsX6j/Asset-3-2x-Official-Kcalose.png',
        paragraphs: [
            "Kcalose is a Web 3.0 dApp built on ETHW chain with the vision of enabling the interoperability of blockchain technology and traditional fitness ecosystems – all while promoting advance fitness standards and rewarding fitness enthusiasts from all over the world. With specially designed \"move-to-earn\" mechanics, Kcalose users can receive rewards for participating in a variety of sports including running, swimming, cycling, workout and more than that. Every calorie burned counts!",
            "Kcalose's app allows users to directly link to all major fitness watches and mobile apps including Garmin, Fitbit, and Strava (Apple Health and Google Fit coming soon). This allows for a seamless submission process where activity results can be uploaded automatically from your device. With this application we are able to bring people with different devices together to interact, compete, and support one another in the Kcalose community.",
        ],
        chains: [ETHW, ETC],
    },
    {
        name: 'LikeNetwork',
        tags: [SOCIAL, NFT],
        description: 'A completely decentralized and permissionless social graph protocol, allowing NFT to swim WEB3 as an underlying facility.Based on ClassZZ tech.',
        links: {
            [WEBSITE]: 'https://linke.network',
            [TWITTER]: 'https://twitter.com/LinkeNetwork',
        },
        image: 'https://pbs.twimg.com/profile_images/1535100288549257221/_8C59Id6_400x400.jpg',
        paragraphs: [
            "With the combination of socialfi and gamefi, LikeNetwork aims to drive millions of people to the virtual digitization of social networking and the effective precision of social networking, making it easier to connect the public to Web 3.0, while relying on Socialfi to build a lasting platform to cultivate User-generated Web 3.0 content.",
        ],
        chains: [ETHW, ETC],
    },

    /*
    {
        name: 'J2O',
        tags: [DEFI, GAMEFI],
        description: "We fork optimism. deploy L2 for jfinchain so we need to deploy L2 for ETH POW too.",
        links: {
            [WEBSITE]: 'https://j2o.io',
            // [TWITTER]: 'https://twitter.com/joker_manor',
            // [GITHUB]: 'https://github.com/classzz',
            // [TELEGRAM]: 'https://t.co/2GaKveDGbL',
        },
        image: 'https://i.postimg.cc/nLcJXSpD/Stw-EPI-Dome-Charoenyost.jpg',
        // paragraphs: [
        //     "Through ClassZZ main net and the protocol it uses - Te Waka protocol, native tokens are exchanged. Mapped tokens are unable to participate in the DeFi activities, making them less attractive to users. Thus, native tokens are needed to participate and trade. Exchanges using native tokens are straightforward rather than indirect through centralized exchange services.",
        // ],
        chains: [ETHW],
    },
    */
    {
        name: 'jokerfi',
        tags: [DEFI, GAMEFI],
        description: "JokerManor Metaverse (JKT) - GameFi & DeFi Metaverse's, latest and popular Aggregator & Launchpad.",
        links: {
            [WEBSITE]: 'https://jokerfi.com/',
            [TWITTER]: 'https://twitter.com/joker_manor',
            // [GITHUB]: 'https://github.com/classzz',
            [TELEGRAM]: 'https://t.co/2GaKveDGbL',
        },
        image: 'https://i.postimg.cc/cCRG8VCf/Logo-Matt-Wang.jpg',
        // paragraphs: [
        //     "Through ClassZZ main net and the protocol it uses - Te Waka protocol, native tokens are exchanged. Mapped tokens are unable to participate in the DeFi activities, making them less attractive to users. Thus, native tokens are needed to participate and trade. Exchanges using native tokens are straightforward rather than indirect through centralized exchange services.",
        // ],
        chains: [ETHW],
    },
    {
        name: 'King Lottery',
        tags: [GAMEFI],
        description: "A completely decentralized and full-automated lotteries.",
        links: {
            [DAPP]: 'https://king-lottery.com/',
        },
        image: 'https://encrypted-tbn0.gstatic.com/favicon-tbn?q=tbn%3AANd9GcSNDI9wA0IFrjRN_2PHEi5AxSxH40mqu8VqJ4CzQnayybzMmWmDl0v2Re3ejMK570aeTmGabmIXhC08QsArVFNKzbtNTr2f_RzfpwM',
        chains: [ETHW],
    },
    {
        name: 'Mega Maby',
        tags: [NFT, NATIVE_NFT],
        description: "Mega Maby is the first pixelated AI soldier with 1020 NFTs on Ethereum POW. The gateway to Web3 & Metaverse through multiple real-life ultiilities.",
        links: {
            [WEBSITE]: 'https://www.megamaby.xyz/',
            [DAPP]: 'https://www.megamaby.xyz/',
        },
        image: 'https://i.postimg.cc/LsQqtWBV/Megamaby1-2-Mega-Maby-1.png',
        chains: [ETHW],
    },
    {
        name: 'MetaSill',
        tags: [NFT, INFRA, MARKETPLACES],
        description: "MetaSill provides software+hardware solution for events and galleries. Its high-end NFT frames fully dedicated to showcase authenticated NFTs straight from the MetaSill app connected to a crypto wallet. The slim, high-quality design offers the best visual NFT experience while aesthetically elevating its surrounding.",
        links: {
            [WEBSITE]: 'https://www.metasill.io',
            [TWITTER]: 'https://twitter.com/metasill',
            // [GITHUB]: 'https://github.com/classzz',
            // [TELEGRAM]: 'https://t.co/2GaKveDGbL',
        },
        image: 'https://i.postimg.cc/mrkH4ZXB/a-X55-Lb2-A-400x400.jpg',
        isVerified: true,
        // paragraphs: [
        //     "MetaSill provides software+hardware solution for events and galleries. Its high-end NFT frames fully dedicated to showcase authenticated NFTs straight from the MetaSill app connected to a crypto wallet. The slim, high-quality design offers the best visual NFT experience while aesthetically elevating its surrounding. ",
        // ],
        chains: [ETHW],
    },
    {
        name: 'Meme Coin Mafia',
        tags: [MEMECOINS],
        description: "A collection of meme coins airdropped to holders of $M3M3",
        links: {
            [WEBSITE]: 'http://memecoinmafia.xyz/',
            [TWITTER]: 'https://twitter.com/mmCaptainBigmac',
            [TELEGRAM]: 'https://t.me/meme_coin_mafia',
        },
        image: 'https://i.postimg.cc/43k0Q8B0/111222333444555-Meme-TV.png',
        paragraphs: [
            "Simply a collection of meme coins, airdropped to holders of $M3M3.",
        ],
        chains: [ETHW],
    },
    {
        name: 'MEMETIGO',
        tags: [MEMECOINS],
        description: "THE TIGO TALES Once a memecoin becomes popular and skyrockets in value, retail investors sometimes go along for the ride and boost the coin even further. Celebrities and influencers also boost the popularity of certain meme-based coins.",
        links: {
            [WEBSITE]: 'https://memetigo.co/',
            [TWITTER]: 'https://twitter.com/TigocoinMEME',
            [TELEGRAM]: 'https://t.me/Tigocoin',
            [FACEBOOK]: 'https://www.facebook.com/Tigo-coin-102884015919749/',
        },
        image: 'https://i.postimg.cc/cJrtGNJb/msg643016208-66286-fr-hyt.jpg',
        paragraphs: [
            "Disclaimer: This is a community driven project, which mean everyone need to work hard together and spread TIGO like a virus or nothing going to happen. Let’s create a supportive and motivated community of holders who are ready to work hard, hustle, contribute & risk it all for our one common goal! Together, we can launch TIGO to the Moon and beyond! Please understand TIGOCOIN is not an investment. Before we build all the utilities, TIGO was initially created as a meme just like DOGE and SHIBA. MEME Tigocoin make no promises and is not responsible for any losses or errors. Use at your own ris.",
        ],
        chains: [ETHW],
    },
    {
        name: 'MetaMask',
        tags: [INFRA, WALLET],
        description: 'A crypto wallet & gateway to blockchain apps.',
        links: {
            [WEBSITE]: 'https://metamask.io',
            [TWITTER]: 'https://twitter.com/MetaMask',
            [GITHUB]: 'https://github.com/MetaMask/metamask-extension',
        },
        image: 'https://awesome-near.s3.amazonaws.com/metamask.jpg',
        paragraphs: [
            'Available as a browser extension and as a mobile app, MetaMask equips you with a key vault, secure login, token wallet, and token exchange—everything you need to manage your digital assets.',
            'MetaMask provides the simplest yet most secure way to connect to blockchain-based applications. You are always in control when interacting on the new decentralized web.',
            'MetaMask generates passwords and keys on your device, so only you have access to your accounts and data. You always choose what to share and what to keep private.'
        ],
        chains: [ETHW, ETC, ETF],
        isVerified: true,
    },
    {
        name: 'Metawork',
        tags: [METAVERSE],
        description: "Work from metaverse.",
        links: {
            [WEBSITE]: 'https://www.metawork.business/',
            [TWITTER]: 'https://twitter.com/MetaworkB',
            [FACEBOOK]: 'https://www.facebook.com/metawork.business/',
            [TELEGRAM]: 'https://t.me/+609Uw6U0hA5jZGE0',
        },
        image: 'https://pbs.twimg.com/profile_images/1559904193107922945/B5jscfO3_400x400.jpg',
        paragraphs: [
            "Initial stage just idea and web ready.",
            "I make idea and also webpage now looking forward to built coin also if project gives me good price I will sell it",
        ],
        chains: [ETHW],
    },
    /*
    {
        name: 'MinerSwap',
        tags: [EXCHANGES, DEFI, DAPP],
        description: "MinerSwap is the first hybrid StableSwap / Uniswap V2 DEX on EthereumPoW. Swap, farm, and stake tokens to earn MSP and earn additional yields.",
        links: {
            [WEBSITE]: 'https://minerswap.fi',
            [DAPP]: 'https://minerswap.fi',
            [TWITTER]: 'https://twitter.com/minerswapfi',
            [DISCORD]: 'https://discord.gg/kPmsWNDarq',
            [GITHUB]: 'https://github.com/minerswap',
            [MEDIUM]: 'https://medium.com/@minerswapfi',
            [TELEGRAM]: 'https://t.me/minerswapfi',
        },
        image: 'https://i.postimg.cc/7ZgxT3p6/256-Miners-Degen.png',
        paragraphs: [
            "MinerSwap is the first Uniswap V2 and Curve like StableSwap Dex that supports various kinds of AMM formulas with a dynamic trading fee for token developers. You can swap your stablecoins or pegged tokens with much lower slippages with less pair liquidity requirements.",
        ],
        chains: [ETHW],
    },
    */
    {
        name: 'Moon APE PoW Club',
        tags: [NATIVE_NFT],
        description: "We're officially the first ever NFT Collection on EthereumPOW chain.",
        links: {
            [WEBSITE]: 'https://moonapepowclub.com/',
            [TWITTER]: 'https://twitter.com/moonapepowclub',
        },
        image: 'https://pbs.twimg.com/profile_images/1571333713912537090/HAdAJrnw_400x400.jpg',
        isVerified: true,
        chains: [ETHW],
    },
    {
        name: 'Nabox',
        tags: [INFRA, WALLET],
        description: "Multi-chain Wallet | DApp Explorer | Cross-Chain Swap",
        links: {
            [WEBSITE]: 'https://nabox.io/',
            [TWITTER]: 'https://twitter.com/naboxwallet',
            [DISCORD]: 'https://discord.gg/mQVXZJXMkn',
            [MEDIUM]: 'https://naboxwallet.medium.com',
            [TELEGRAM]: 'https://t.me/naboxcommunity',

            
        },
        image: 'https://forum.nabox.io/user_avatar/forum.nabox.io/nabox/240/3_2.png',
        paragraphs: [
            "Nabox is a cross-chain DID application built for Web3. With Nabox, you can manage assets across different blockchains whether for DeFi, GameFi, NFTs, and other use cases that come up. Nabox is your gateway to the multi-chain world.",
            "Nabox uses an asymmetric cryptographic algorithm as the basis of Nabox's DID. Users use the same set of keys and public keys to manage assets and data on different blockchains.",
            "SwapBox aggregates mainstream DEXs to provide users with asset exchange and asset cross-chain exchange, and intelligently find the best exchange path.",
        ],
        chains: [ETC, ETHW],
    },
    {
        name: 'NFTWswap',
        tags: [DEFI, EXCHANGES, NFT],
        description: "NFTWswap is an all-in-one NFT marketplace, dex , launchpad, lending borrow.",
        links: {
            [WEBSITE]: 'https://www.nftwswap.com/',
            [TWITTER]: 'https://twitter.com/nftwswap',
            [GITHUB]: 'https://github.com/NFTW-Swap',
            [MEDIUM]: 'https://medium.com/@nftwswap',
            [TELEGRAM]: 'https://t.me/nftwswap_global',

            
        },
        image: 'https://i.postimg.cc/NGk2m11F/logo-Quang-Nguyen.png',
        // paragraphs: [
        //     "Nabox is a cross-chain DID application built for Web3. With Nabox, you can manage assets across different blockchains whether for DeFi, GameFi, NFTs, and other use cases that come up. Nabox is your gateway to the multi-chain world.",
        //     "Nabox uses an asymmetric cryptographic algorithm as the basis of Nabox's DID. Users use the same set of keys and public keys to manage assets and data on different blockchains.",
        //     "SwapBox aggregates mainstream DEXs to provide users with asset exchange and asset cross-chain exchange, and intelligently find the best exchange path.",
        // ],
        chains: [ETC, ETHW],
    },
    {
        name: 'NOWPayments',
        tags: [PAYMENTS],
        description: "NOWPayments is the easiest way to accept online payments in a wide variety of cryptocurrencies. This service is custody-free, has competitive fees, and is available worldwide.",
        links: {
            [WEBSITE]: 'https://nowpayments.io/',
            [TWITTER]: 'https://twitter.com/NOWPayments_io',
            [GITHUB]: 'https://github.com/NowPaymentsIO',
            [FACEBOOK]: 'https://www.facebook.com/NOWPayments.io',
        },
        image: 'https://pbs.twimg.com/profile_images/1351091723833909248/9Jqk2Tiu_400x400.jpg',
        paragraphs: [
            "We provide not only payments but donations and payouts in over 150+ cryptos, autoconversion and fiat withdrawals.",
            "NOWPayments is a non-custodial crypto payment gateway that lets you accept payments in 100+ cryptocurrencies, with auto coin conversion available. Regardless of what crypto customers pay with, merchants can choose to accept the coins they prefer - NOWPayments converts them automatically.",
            "Pricing: 0,5% transaction fee + 0,5% exchange fee if exchange is needed.",
            "The platform also supports fiat conversion, and offers customized Casino solutions, Twitch donation button, a Mass Payouts solution and a point-of-sale link.",
            "NOWPayments provides merchants with a variety of tools: API, invoices, donation widget, buttons, as well as plugins for WooCommerce, ZenCart, PrestaShop, Opencart, WHMCS, Magento 2 and others.",
            "NOWPayments is a non-custodial payment gateway,which means that all your payments will be instantly transferred to your own wallet that only you can have access to.",
        ],
        chains: [ETHW, ETC],
    },
    {
        name: 'Nswap',
        tags: [NFT, MARKETPLACES],
        description: "Nswap is an all-in-one NFT marketplace, launchpad, and raffle generator. Trading with 0% service fee.",
        links: {
            [WEBSITE]: 'https://www.nswap.com/',
            [TWITTER]: 'https://twitter.com/Nswapcom',
            [DISCORD]: 'http://discord.gg/nswap',
            [MEDIUM]: 'https://medium.com/nswap',
            [TELEGRAM]: 'https://t.me/nswapdao',
        },
        image: 'https://i.postimg.cc/rptjcQ6h/nswaplogo.png',
        isVerified: true,
        paragraphs: [
            "Nswap is building a decentralized, multi-chain information aggregation platform (Launchpad) and open market (Marketplace) for NFTs. We hope that everyone has the opportunity to experience, access, and own NFTs. With Nswap, you can access NFT collections for sale on our primary Launchpad and trade them freely on our secondary Marketplace.",
        ],
        chains: [ETHW],
    },
    {
        name: 'NOW Wallet',
        tags: [INFRA, WALLET],
        description: "NOW Wallet is a non-custodial mobile cryptocurrency wallet. We will support ETHW after the fork - our users will be able to securely store $HBAR, buy it with fiat, and exchange it right in the app.",
        links: {
            [WEBSITE]: 'https://walletnow.app/',
            [TWITTER]: 'https://twitter.com/ChangeNOW_io',
            // [DISCORD]: 'http://discord.gg/nswap',
            [MEDIUM]: 'https://changenow-io.medium.com/',
            [TELEGRAM]: 'https://t.me/changeNOW_chat',
        },
        image: 'https://i.postimg.cc/6qyB2HR0/now-wallet-logo-Alena-Ignatuk.png',
        // paragraphs: [
        //     "Nswap is building a decentralized, multi-chain information aggregation platform (Launchpad) and open market (Marketplace) for NFTs. We hope that everyone has the opportunity to experience, access, and own NFTs. With Nswap, you can access NFT collections for sale on our primary Launchpad and trade them freely on our secondary Marketplace.",
        // ],
        chains: [ETHW],
    },
    {
        name: 'Nuwton',
        tags: [DEFI, NFT, MARKETPLACES],
        description: "The first NFT marketplace for EthereumPOW chain.",
        links: {
            [WEBSITE]: 'https://nuwton.io/',
            [TWITTER]: 'https://twitter.com/NuwtonNFT',
            [DISCORD]: 'https://discord.com/invite/kwkCcB7YWw',
        },
        image: 'https://i.postimg.cc/xdD2QDqH/Wechat-IMG297.jpg',
        isVerified: true,
        chains: [ETHW],
    },
    {
        name: 'OKDEX',
        tags: [EXCHANGES, DEFI, INFRA],
        description: "OKDEX exchange of the ETHW, First to launch DEX with decetralized book order at EthereumPoW.",
        links: {
            [WEBSITE]: 'https://okdex.trade/',
            [TWITTER]: 'https://twitter.com/Okdex_trade',
            [MEDIUM]: 'https://medium.com/@okdex',
            [TELEGRAM]: 'https://t.me/okdexglobal',
        },
        image: 'https://i.postimg.cc/Jz8qrC7Y/photo-2022-08-22-10-52-51-Luiz-Henrique-lopes-jayme.jpg',
        paragraphs: [
            "OKDEX exchange of the ETHW, First to launch DEX with decetralized book order at EthereumPoW.",
        ],
        chains: [ETHW],
    },
    {
        name: 'Crypto Butchers NFT',
        tags: [NFT, MARKETPLACES],
        description: "We are an NFT project with successful collections on the networks, Solana, Moonriver and Dogechain.",
        links: {
            [WEBSITE]: 'https://cryptobutchers.com/',
            [TWITTER]: 'https://twitter.com/CryptoButchers',
            [DISCORD]: 'https://discord.com/invite/PSxdGGdHZj',
            [INSTAGRAM]: 'https://www.instagram.com/cryptobutchers/',
            [TELEGRAM]: 'https://t.me/CryptoButchers',
        },
        image: 'https://pbs.twimg.com/profile_images/1571909424721051648/P877qRBO_400x400.jpg',
        paragraphs: [
            "CRYPTO BUTCHERS starts as a classic PFP NFT project randomly created in the candy machine style. Dedicated to cyberpunk art and culture with pixel art, BUTCHER adds value to its metaverse project as timeless Punk, opening new doors and possibilities for builders, investors, brands and fans.",
        ],
        chains: [ETHW],
    },
    {
        name: 'Fliperino',
        tags: [DEFI],
        description: "It is the first of it's kind ETHW double or nothing for fun website where a simple random math 50/50 contract makes your ETHW either double itself from the prize pool or not.",
        links: {
            [WEBSITE]: 'https://fliperino.xyz/',
            [DAPP]: 'https://fliperino.xyz/',
            [TWITTER]: 'https://twitter.com/Fliperino2',
        },
        image: 'https://i.postimg.cc/pXQMLNdS/logo-Leko-Pepo.png',
        paragraphs: [
            "Fliperino is a ETHW smart contract that ensures a 50/50 probability of either doubling your ETHW from your community prize pool or getting assimilated to the total balance while awarding you with FLIP token which ensures you are getting rewards every 24 hours in ETHW.",
        ],
        chains: [ETHW],
    },
    {
        name: 'FoxWallet',
        tags: [WALLET],
        description: "FoxWallet is a decentralized multi-chain Web3 wallet dedicated to creating a connection and entrance to the Web3 world.",
        links: {
            [WEBSITE]: 'https://foxwallet.com',
            [TWITTER]: 'https://twitter.com/FoxWallet',
            [DISCORD]: 'https://discord.com/invite/JVjVbe3Zth',
            [GITHUB]: 'https://github.com/madfoxoO/FoxWallet#foxwallet',
            [MEDIUM]: 'https://medium.com/@FoxWallet',
            [TELEGRAM]: 'https://t.me/FoxWallet_EN',
        },
        image: 'https://pbs.twimg.com/profile_images/1476111948236587013/A2hj77az_400x400.jpg',
        paragraphs: [
            "Multi-chain and multi-address wallet; providing data on miners; full support of Filecoin ecosystem; listed on the official Ethereum wallet list.",
            "FoxWallet is a decentralised audited Web3 wallet that aims at creating an entrance and connection to the Web3 world. The idea for FoxWallet launch originated from Filecoin developer community by giving a start to FilFox browser and, as of now, being the only official wallet in the Filecoin ecosystem as well as one of the officially recognised Ethereum wallets.",
            "FoxWallet is a multi-chain and multi-address digital asset storage that provides flexible switching between accounts as well as an incredibly simple and sophisticated UI. Focusing on creating a gateway to the Web3 world, FoxWallet combines simplicity of its usage and design with complexity of the features it has, particularly, mining-related services, updates on on-chain data, NFT support, fiat on-ramps and future staking features.",
            "FoxWallet puts a lot of effort on enhancing Web3 adoption by allowing creating bookmarks for favourited pages, getting to know about supported chains and their ecosystems as well as learn-to-earn incentives.",
        ],
        chains: [ETHW],
    },
    {
        name: 'Frogs PoW',
        tags: [NFT, NATIVE_NFT],
        description: "We are new but we will build a great for the growth ethereumPow ecosystem.",
        links: {
            [WEBSITE]: 'https://frogs-pow.com',
            [TWITTER]: 'https://twitter.com/FrogsPow?t=eEUyvYzA_uJOukLEL8Ekgg&s=09',
            [DISCORD]: 'https://discord.gg/mvnjqUg8SB',
            [GITHUB]: 'https://github.com/FrogpowNFT',
            [TELEGRAM]: 'https://t.me/FrogsPoW',
        },
        image: 'https://i.postimg.cc/qvXJShnz/Untitled-436-Frog-Pow.png',
        chains: [ETHW],
    },
    {
        name: 'HEX',
        tags: [DAPPS, DEFI],
        description: "HEX is the first blockchain CD Certificate of Deposit. Hex has no middle men, no counterparty risk, no bureaucracy and no overheads. There are no bonuses awarded to anyone outside of the users who stake HEX.",
        links: {
            [WEBSITE]: 'https://hex.com/',
            [DAPP]: 'https://go.hex.com/',
            [TWITTER]: 'https://twitter.com/HEXcrypto',
            [GITHUB]: 'https://github.com/BitcoinHEX',
        },
        image: 'https://pbs.twimg.com/profile_images/1108238654680547328/lw48dq30_400x400.jpg',
        paragraphs: [
            "Trustless yield, immutable code, no admin keys, no counterparty risk, no bureaucracy and no overheads. As a simple to use, high-yield investment tool, HEX makes you the bank. Highly engaged, rapidly growing community that is supportive, innovative, and passionate.",
            "Certificates of Deposit (CDs) are common investment tools managed by banks. Hundreds of millions of people use them worldwide, creating a market valued in the trillions of dollars. HEX has taken the concept of CDs, added significantly higher average return rates, removed banking fees and turned it into a decentralized cryptocurrency.",
            "You can \"stake\" your HEX by locking up any amount for a period between 1 and 5555 days. Your Stake accrues rewards every day, and the amount of yield depends on the length of your Stake: \"Longer Pays Better\". In addition to the unprecedented yield, there is also the tendency of the HEX price to appreciate.",
            "HEX has no central entity, no bureaucracy and no overhead. There are no bonuses awarded to anyone outside of the users who Stake HEX. As a simple to use, high-yield investment tool, HEX makes you the bank.",
        ],
        chains: [ETC, ETHW],
    },
    {
        name: 'KyberSwap',
        tags: [DEFI, EXCHANGES],
        description: "DEX and Aggregator",
        links: {
            [WEBSITE]: 'https://kyberswap.com/about/kyberswap',
            [DAPP]: 'https://kyberswap.com/swap',
            [TWITTER]: 'https://twitter.com/KyberNetwork',
            [DISCORD]: 'https://discord.com/invite/NB3vc8J9uv',
            [GITHUB]: 'https://github.com/KyberNetwork',
            [FACEBOOK]: 'https://www.facebook.com/kyberswap',
            [TELEGRAM]: 'https://t.me/kybernetwork',
        },
        image: 'https://pbs.twimg.com/profile_images/1524960352156254209/WbKClu_V_400x400.jpg',
        paragraphs: [
            "KyberSwap is a decentralized exchange (DEX) aggregator. We provide our traders with the best token prices by analyzing rates across thousands of exchanges instantly!",
            "KyberSwap is also an automated market maker (AMM) with industry-leading liquidity protocols and concentrated liquidity. Liquidity providers can add liquidity to our pools & earn fees!",
        ],
        chains: [ETHW],
    },
    {
        name: 'LFG SWAP',
        tags: [DEFI, EXCHANGES],
        description: "LFGSwap is a community-driven organization built to solve what might be called the “liquidity problem.” One could define this problem as the inability of disparate forms of liquidity to connect with markets in a decentralized way, and vice versa. While other solutions provide incrementally progressive advances toward solving the problem of liquidity, LFGSwap’s progress is intended to create a broader range of network effects. Rather than limiting itself to a single solution, LFGSwap intertwines many decentralized markets and instruments.",
        links: {
            [WEBSITE]: 'https://app.lfgswap.finance',
            [TWITTER]: 'https://twitter.com/LfgSwap',
            [GITHUB]: 'https://github.com/LfgSwap',
            // [MEDIUM]: 'https://medium.com/@FoxWallet',
            [TELEGRAM]: 'https://t.me/LFGSWAPFINANCE',
        },
        image: 'https://pbs.twimg.com/profile_images/1565362785436872705/zwgHVtpW_400x400.jpg',
        paragraphs: [
            "Thus far, the core products, which will be described in more detail here, include: a decentralized exchange, yield instruments, an auction platform, an AMM framework and staking derivatives. LFGSwap's products are configured in a way that allows the entire platform to maintain decentralized governance of $LFG token holders, while continuing to innovate on the collective foundations by design. Whereas major structural changes are voted on by the community, the day-to-day operations, rebalancing of pools and ratios, business strategy and overall development is ultimately decided on by our core team.",
        ],
        chains: [ETHW],
    },
    {
        name: 'Maximus DAO',
        tags: [DEFI, UTILITIES, DAPPS],
        description: "Maximus DAO is a liquid staking solution for HEX on Ethereum. Maximus stake pools allow people to maximize yield, save on gas fees and have instant liquidity.",
        links: {
            [WEBSITE]: 'https://www.maximusdao.com/',
            [TWITTER]: 'https://twitter.com/maximus_dao',
            [TELEGRAM]: 'https://t.me/MaximusDAO',
        },
        image: 'https://pbs.twimg.com/profile_images/1551620719213027333/MjTXlAXi_400x400.jpg',
        paragraphs: [
            "Earn passive income and invest for a better future. ⚔️",
            "With Maximus, you can earn more yield, save on gas fees, and stake liquid through our trustless smart contract. Maximus stake pools are innovative smart contracts that enable people to trustlessly stake HEX together to get bigger bonuses, and by consolidating thousands of end stake fees to just one, 99.9% of people won’t have to pay.",
        ],
        chains: [ETHW],
    },
    {
        name: 'Meo Finance',
        tags: [DEFI, EXCHANGES],
        description: "MeoFinance is a DEX on multichain for all crypto and an NFT exchange. We also exchange crypto for fiat to your bank account in the currency of your choice. Low fees and secure.",
        links: {
            [WEBSITE]: 'https://meo.finance',
            [DAPP]:'https://meo.finance',
            [TWITTER]: 'https://twitter.com/MeoFinance',
            [DISCORD]: 'https://discord.gg/KpZUJn4B2S',
            [TELEGRAM]: 'https://t.me/meofinance',
        },
        image: 'https://i.postimg.cc/L5CwF0R8/cat2-svg-Neko-Bite.png',
        paragraphs: [
            "Experienced founder with a growing community.",
        ],
        chains: [ETHW],
    },
    {
        name: 'Metroswap',
        tags: [DEFI, EXCHANGES],
        description: "Metroswap is unstoppable liquidity on EthereumPoW.",
        links: {
            [WEBSITE]: 'https://metroswap.org',
            [DAPP]:'https://app.metroswap.org',
            [TWITTER]: 'https://twitter.com/tetcoin',
            [GITHUB]: 'https://github.com/metrodao',
        },
        image: 'https://i.postimg.cc/NM9vfcJr/xmn100-Marlon-Hanks.png',
        paragraphs: [
            "Metroswap is decentralized exchange on EVM Networks.",
        ],
        chains: [ETHW],
    },
    {
        name: 'NFTWpad',
        tags: [NFT, LAUNCHPAD],
        description: "Founder wPass is the official collection released by NFTwPad - No 1 launchpad to escalate the booming of NFT in EthereumPoW blockchain.",
        links: {
            [WEBSITE]: 'https://nftwpad.io/',
            [DAPP]: 'https://nftwpad.io/',
            [TWITTER]: 'https://twitter.com/NFTwPad',
            [TELEGRAM]: 'https://t.me/NFTwPad',
            [DISCORD]: 'https://discord.com/invite/Cg5xnwPd77',
        },
        image: 'https://i.postimg.cc/KjJ6mDcG/Frame-1-Sugar-Miziz.png',
        paragraphs: [
            "Own wPass to access the previlege of NFTwPad",
            "1. Launch NFT project. Burning wPass to launch your NFT project in NFTwPad and get fully marketing supports.",
            "2. NFT Whitelist. Staking wPass to get guaranteed whitelist slot for all NFT collection launched in Launchwpad.",
            "3. Revenue sharing. Receiving revenue of Launchwpad as a passive income.",
            "NFTwPad",
            "Launchwpad for NFT Project",
            "No 1 launchpad to escalate the booming of NFT in EthereumPoW blockchain. WAGMI!",
            "- No-code, easy to air",
            "- NFT Art Generator",
            "- Marketing Support from the ecosystem",
        ],
        chains: [ETHW],
    },
    {
        name: 'OpenSeaLand',
        tags: [NFT],
        description: "Play to Earn & A virtual gaming world where players can build on ETHW.",
        links: {
            [WEBSITE]: 'https://www.openseanft.land/',
            [TWITTER]: 'https://twitter.com/OpenSeaIsland',
        },
        image: 'https://pbs.twimg.com/profile_images/1559810955458011137/juQfukER_400x400.jpg',
        chains: [ETHW],
    },
    {
        name: 'Open Tigers',
        tags: [NFT, NATIVE_NFT],
        description: "The Genesis NFT creation and OG pass of the OpenW NFT marketplace.",
        links: {
            [WEBSITE]: 'https://www.opentigers.com/',
            [TWITTER]: 'https://twitter.com/OpenTigersNFT',
            [DISCORD]: 'https://discord.com/invite/OpenW',
            [TELEGRAM]: 'https://t.me/+3Wk-MC6q20xhM2M0',
        },
        isVerified: true,
        image: 'https://i.postimg.cc/5NWxLF2g/WX20221011-092524-2x.png',
        chains: [ETHW],
        paragraphs: [
            "The hottest OG NFT project on the ETHW chain.  Buy an OpenTiger NFT on ETHW to become our member. Supported by Wagmi33 Foundation.",
        ],
    },
    {
        name: 'OpenW',
        tags: [NFT, MARKETPLACES],
        description: "The largest NFT marketplace on EthereumPoW. Buy, sell & discover the internet of goods.  Supported by Wagmi33 Foundation.",
        links: {
            [WEBSITE]: 'https://www.openwnft.xyz/',
            [TWITTER]: 'https://twitter.com/OpenPowNFT',
            [DISCORD]: 'https://discord.gg/GBqku6PP',
            [TELEGRAM]: 'https://t.me/+3Wk-MC6q20xhM2M0',
        },
        isVerified: true,
        image: 'https://i.postimg.cc/zBZrKVCK/0-E52-C015-D43-E-422-C-AA46-693-DA3-CC1-D6-F-Zhao-Glroa.jpg',
        chains: [ETHW],
        paragraphs: [
            "The NFT marketplace with the largest user community and the highest number of Twitter followers on the ethw blockchain. Supported by Wagmi33 Foundation.",
        ],
    },
    {
        name: 'PandaPOW',
        tags: [NFT, UTILITIES],
        description: "The first panda community on proof of work. Mint nft hold it get reward token $BMB every week. Hold $BMB get automatically trading fees payed in ETHW directly in your wallet. Reject humanity, return to Panda. Welcome to your home forest.",
        links: {
            [WEBSITE]: 'https://www.pandapow.me',
            [TWITTER]: 'https://twitter.com/pandapow_nft',
        },
        image: 'https://i.postimg.cc/Fsfk5dV9/logo192-IAnft-Vault-X-IA.png',
        chains: [ETHW],
    },
    {
        name: 'Pandasale',
        tags: [DEFI, LAUNCHPAD],
        description: "As a user-orientated Launchpad platform, PandaSale focuses on facilitating a balanced and mutually beneficial environment for both investors and project owners.",
        links: {
            [WEBSITE]: 'https://pandasale.finance/',
            [DAPP]: 'https://pandasale.finance/?chain=ETHW',
            [TWITTER]: 'https://twitter.com/Panda_Ecosystem',
            [MEDIUM]: 'https://medium.com/@pandasale',
            [TELEGRAM]: 'https://t.me/PandaEcosystem',
        },
        image: 'https://pbs.twimg.com/profile_images/1532453681127473177/jIICu7UE_400x400.jpg',
        paragraphs: [
            "As a user-orientated platform, PandaSale focuses on facilitating a balanced and mutually beneficial environment for both investors and project owners.",
            "PandaSale not only provides the next generation, all-in-one DeFi Launchpad for all EVM-powered networks but also integrates many other complimentary services (Marketing, KYC audit, Contests, etc.) under the same platform.",
            "Having many partners in the crypto space, PandaSale provides access to many discount services which raise project success rate.",
            "PandaSale is financially accessible and simple to use for both investors and project owners.",
            "Our unique design not only assures the best possible project launch but also creates the conditions to help the project keep growing after launch.",
        ],
        chains: [ETHW],
    },
    {
        name: 'PaperDAO',
        tags: [LENDING, DEFI],
        description: "PaperDAO is lending market for ETHW and stablecoin minter.",
        links: {
            [WEBSITE]: 'https://paperdao.money/',
            [DAPP]: 'https://app.paperdao.money/',
            [TWITTER]: 'https://twitter.com/paperdaomoney',
            [DISCORD]: 'https://discord.gg/2ST5u7HwbJ',
            [GITHUB]: 'https://github.com/paperdao-money',
        },
        image: 'https://i.postimg.cc/GmPmDmTR/paperdao-gitbook-Paper-DAO.png',
        paragraphs: [
            "PaperDAO is a suite of products to kick start the ETH PoW ecosystem. We are PoW maximalists and do not buy into the energy usage rhetoric forwarded by PoS promoters.",
            "We have an opportunity to create a healthy DEFI ecosystem from scratch now that we have a clean starting point on an EVM compatible chain which does not have custodial assets such as USDC on it.",
            "To start with, we are building a lending market to supply and borrow ETHW, alongside a native stablecoin $USW which anyone can mint.",
        ],
        chains: [ETHW],
    },
    {
        name: 'Pee NFT',
        tags: [NFT, NATIVE_NFT],
        description: "An NFT collection of mysterious creatures from the parallel world. Collect and tame those creatures to save the world!",
        links: {
            [WEBSITE]: 'https://pee.wtf/',
            [TWITTER]: 'https://twitter.com/peenft',
            [DISCORD]: 'https://discord.com/invite/peeupsidedown',
        },
        image: 'https://pbs.twimg.com/profile_images/1550221567505874944/SKcFeFSl_400x400.jpg',
        paragraphs: [
            "Pee Upside Down NFT is a collection of 11,000 mysterious creatures from the parallel world that are trying to destroy the human financial system. The portal between the two worlds is now open, and only the bravest and strongest can confront them. Collect and tame those creatures to restore the balance of the world.",
        ],
        chains: [ETHW],
    },
    {
        name: 'PinkPanther',
        tags: [NFT, MEMECOINS],
        description: "PINKPANTHER CLUB NEW MEMES COMMUNITY TOKEN ON ETHEREUMPOW, WE ARE CREATE A SUPER RARE NFT GENERATE WITH AI IF YOU LOVE NFT ART THIS IS THE RIGHT PLACE",
        links: {
            [WEBSITE]: 'https://pinkpanthers.lol',
            [DAPP]: 'https://pinkpanthers.lol',
            [TWITTER]: 'https://twitter.com/pinkpanthersme',
            [TELEGRAM]: 'https://t.me/pinkpantherme',
        },
        image: 'https://i.postimg.cc/W1HxS5TM/logocoin-pink-panther.png',
        chains: [ETHW],
    },
    {
        name: 'PoorPleb',
        tags: [MEMECOINS],
        description: "PoorPleb (PP) is a zero utility ERC20 memecoin on the Ethereum network and EthereumPoW network.",
        links: {
            [WEBSITE]: 'https://poorpleb.win/',
            [TWITTER]: 'https://twitter.com/poorplebwin',
            [DISCORD]: 'https://discord.com/invite/azzjDUC9ss',
        },
        image: 'https://pbs.twimg.com/profile_images/1550221567505874944/SKcFeFSl_400x400.jpg',
        paragraphs: [
            "There is nothing groundbreaking here, PoorPleb (PP) is simply a meme token",
            "PoorPlebs will be able to claim a free airdrop, whales will get NOTHING.",
            "PoorPleb (PP) is an experiment designed to enrich the many and exclude the few. If you are a small player in $SHIB, $CULT, $PLS, $FLOKI, $PULSEDOGE and many more you may be eligible to free claim.",
        ],
        chains: [ETHW],
    },
    {
        name: 'Pow APEs',
        tags: [NFT, NATIVE_NFT],
        description: "Pow Apes is degen NFT! A collection of 3 333 unique and randomly generated NFTs chilling in ETHEREUM POW. Each Pow Apes is unique with its own rarity.",
        links: {
            [WEBSITE]: 'https://www.powapes.ml/',
            [DAPP]: 'https://www.powapes.ml/',
            [TWITTER]: 'https://twitter.com/PowApes',
            [TELEGRAM]: 'https://t.me/powAPESNFTS',
        },
        // image: 'https://i.postimg.cc/NG1579Fd/Sapiens-logo-shreyas-r.gif',
        image: 'https://i.postimg.cc/hG51WmNR/sdsadaxzx-sayot3-gaming.png',

       
        // paragraphs: [
        //     "PoWDump is a simple DApp that lets users create cross-chain atomic swaps. This makes it a secure, on-chain way to sell your PoW ETH, which doesn’t rely on centralized exchanges or trusted (wrapped) bridges.",
        // ],
        chains: [ETHW],
    },
    {
        name: 'PoWDump',
        tags: [MARKETPLACES, DEFI, EXCHANGES],
        description: "PoWDump is a simple DApp that lets PoW ETH sellers create atomic cross-chain swaps.",
        links: {
            [WEBSITE]: 'https://dump.today/',
            [DAPP]: 'https://pow.dump.today/',
            [TWITTER]: 'https://twitter.com/DumpPoWETH',
            [GITHUB]: 'https://github.com/brainbot-com/PoWDump',
        },
        image: 'https://pbs.twimg.com/profile_images/1561645789931347968/A6JHC1hn_400x400.jpg',
        paragraphs: [
            "PoWDump is a simple DApp that lets users create cross-chain atomic swaps. This makes it a secure, on-chain way to sell your PoW ETH, which doesn’t rely on centralized exchanges or trusted (wrapped) bridges.",
        ],
        chains: [ETHW],
    },
    {
        name: 'PowEarn',
        tags: [DEFI, EXCHANGES],
        description: "Developed from LIDO FINANCE with improvements to bring more value to users.",
        links: {
            [WEBSITE]: 'https://powearn.com',
            // [DAPP]: 'https://pow.dump.today/',
            [DISCORD]: 'https://discord.com/invite/lido',
            [TWITTER]: 'https://twitter.com/PowEarn',
            [GITHUB]: 'https://github.com/PowEarn',
            [TELEGRAM]: 'https://t.me/lidofinance',
        },
        image: 'https://i.postimg.cc/PfmD1fL6/pe-logo-1024-HD-Sky.png',
        paragraphs: [
        ],
        chains: [ETHW, ETF],
    },
    {
        name: 'Powge',
        tags: [MEMECOINS],
        description: "The first memecoin on $ETHW. The Powge Patrol community is here to meme on the EthereumPoW blockchain.",
        links: {
            [WEBSITE]: 'https://www.powgecoin.com/',
            [TWITTER]: 'https://twitter.com/PowgeCoin',
            [TELEGRAM]: 'https://t.me/powgecoin',
        },
        image: 'https://pbs.twimg.com/profile_images/1572670116948574214/gCeKfdM7_400x400.jpg',
        paragraphs: [
            "First $ETHW memecoin. First $ETHW memecoin listed on the first $ETHW DEX. First $ETHW memecoin to have updated information on Dextools. Essentially the first and leading meme in the space.",
            "Aside from this we have a large, supportive and trusting community built on the foundation of our highly skilled and talented team members.",
            "Our mission is to follow the footsteps and mission of our icons - Shiba and Doge by building a community of like minded individuals built on the foundation of our highly skilled and talented team members.",
            "Our community, the Powge Patrol is engaging, supportive and driven to lead this space with visions unparalleled to any other meme on EthereumPOW.",
        ],
        chains: [ETHW],
    },
    {
        name: 'PowerSwap',
        tags: [DEFI, EXCHANGES],
        description: "PowerSwap is the DEX with the most users in the ETHW ecosystem.",
        links: {
            [WEBSITE]: 'https://powerswap.fi/',
            [DAPP]: 'https://main.powerswap.fi/swap',
            [TWITTER]: 'https://twitter.com/PowerSwapPOW',
            [DISCORD]: 'https://discord.gg/5pHvM6D2Et',
            [TELEGRAM]: 'https://t.me/PowerSwapOfficial',
            [MEDIUM]: 'https://medium.com/@PowerSwapOfficial',
        },
        image: 'https://i.postimg.cc/43Kq6FBc/Kelvin-Russell.png',
        isVerified: true,
        paragraphs: [
            "We launched POWER MAN NFT with free mint and it is very popular. In the future, we will continue to build a high-growth product empowered by POWER MAN nft and POWER token. We named 'Power'Swap because we want to provide the best DEX service for POW supporters. Users can discover the latest and best ETHW projects on PowerSwap.",
        ],
        chains: [ETHW],
    },
    {
        name: 'PowPad',
        tags: [DEFI, LAUNCHPAD],
        description: "POWPAD will empower crypto currency projects with the ability to distribute tokens and raise liquidity.",
        links: {
            [WEBSITE]: 'https://powpad.network/',
            [DAPP]: 'https://powpad.network/launchpad.html',
            [TWITTER]: 'https://twitter.com/powlaunchpad',
            [TELEGRAM]: 'https://t.me/powpad',
            [DISCORD]: 'https://discord.com/invite/Cg5xnwPd77',
        },
        image: 'https://i.postimg.cc/8PTFM7MS/IMG-20221006-225317-838-Rene-Van-dijk.jpg',
        chains: [ETHW],
    },
    {
        name: 'PowSea',
        tags: [EXCHANGES, NFT,MARKETPLACES],
        description: "The #1 NFT Marketplace and DEX on Ethereum PoW",
        links: {
            [WEBSITE]: 'https://powsea.finance/',
            [TWITTER]: 'https://twitter.com/powseafinance',
            [TELEGRAM]: 'https://t.me/PowSea',
        },
        image: 'https://powsea.finance/images/icon.png',
        chains: [ETHW],
    },
    {
        name: 'PowSwap',
        tags: [EXCHANGES, DEFI],
        description: "The first working DEX on ETHW.",
        links: {
            [WEBSITE]: 'https://powswap.io/',
            [DAPP]: 'https://app.powswap.io/',
            [TWITTER]: 'https://twitter.com/powswap_io',
            [GITHUB]: 'https://github.com/powswap',
            [TELEGRAM]: 'https://t.me/powswap',
        },
        image: 'https://pbs.twimg.com/profile_images/1566949815837024256/S3BbB14P_400x400.jpg',
        paragraphs: [
            "We have a community of hunders of people already, and reached ATH of $200K MC for our native token.",
            "Powswap is the first DEX interface to work on ETHPoW. With our app, you interact directly with the existing contracts and liquidity.",
            "We've designed it to be the next step forward. with community-oriented features that we believe help improve the protocol, as well as provide further benefits for all the actors involved.",
        ],
        chains: [ETHW],
    },
    {
        name: 'PowTomb',
        tags: [DEFI, UTILITIES],
        description: "PoWTomb will be the premier yield farming experience to be found on the Ethereum Proof-of-Work (ETHW) chain.",
        links: {
            [WEBSITE]: 'https://powtomb.live/',
            [DAPP]: 'https://powtomb.live/',
            [TWITTER]: 'https://twitter.com/powtomb',
            [GITHUB]: 'https://github.com/PowTomb/',
        },
        image: 'https://i.postimg.cc/t4mSzmRD/Po-WTomb-Logo-Croton-Finance.png',
        paragraphs: [
            'We are a team of experienced developers building for the future of PoW as a consensus protocol. Every budding chain, especially one like PoW needs to be able to follow-up hash-rate with protocol development, and we intend to be a one-stop-shop for high return yield farming for every user of the ETHW chain.',
            'We have started with three tokens, high-yield farming, LP pools, and a single-asset staking pool (the PoWroom). PoWTomb expects to introduce many new features over the coming days and weeks to bring new investors and meet the needs of ETHW.',
        ],
        chains: [ETHW],
    },
    {
        name: 'PowTools',
        tags: [UTILITIES],
        description: "PoWTools is the first Extendable and Public shareable LP locker tool on EthereumPOW.",
        links: {
            [WEBSITE]: 'https://powtools.xyz',
            [DAPP]: 'https://locker.powtools.xyz',
            [TWITTER]: 'https://twitter.com/powtools',
            [GITHUB]: 'https://github.com/POWTOOLS/PoWLocker/blob/main/Locker.sol',
            [TELEGRAM]: 'https://t.me/powtools',
        },
        image: 'https://i.postimg.cc/C5KskL01/photo-5005930339817859752-y-Ilja-Nemesis.jpg',
        paragraphs: [],
        chains: [ETHW],
    },
    {
        name: 'PunkWSwap',
        tags: [EXCHANGES],
        description: "A vision to create the connection of blockchain platforms through a single portal with many utilities. We deliver a professional and intuitive experience across every chain.",
        links: {
            [WEBSITE]: 'https://punkwswap.io/',
            [DAPP]: 'https://app.punkwswap.io/#/swap',
            [TWITTER]: 'https://twitter.com/PunkwSwap',
            [TELEGRAM]: 'https://t.me/PunkWSwap',
        },
        image: 'https://i.postimg.cc/gJHQprJM/tron-Info-Shibchain.png',
        paragraphs: [],
        chains: [ETHW],
    },
    {
        name: '元宇宙ktv | MKTV',
        tags: [NFT],
        description: "MKTV is a Music NFT sing to earn app",
        links: {
            [WEBSITE]: 'https://MKTV.IO/',
        },
        image: 'https://img1.wsimg.com/isteam/ip/14ee5013-43dd-4a41-8b2c-1e54646f4633/89726610.png/:/cr=t:13.24%25,l:22.15%25,w:55.7%25,h:73.53%25/rs=w:730,h:730,cg:true,m',
        paragraphs: [
            'Largest music club on clubhouse',
        ],
        chains: [ETHW],
    },
    {
        name: 'Bitbyte.Finance',
        tags: [DEFI, NFT, INFRA, EXCHANGES, UTILITIES, DEV_TOOLING],
        description: "Bitbyte is a multi-chain platform, mainly focused on providing Web3 builders and users with one-stop customized services.",
        links: {
            [WEBSITE]: 'https://bitbyte.finance/#/',
            [TWITTER]: 'https://twitter.com/Bitbyte_Finance',
            [DISCORD]: 'https://discord.com/invite/RRKCV9PMQv',
            [FACEBOOK]: 'https://www.facebook.com/Bitbyte.Finance',
            [MEDIUM]: 'https://bitbytefinance.medium.com/',
            [TELEGRAM]: 'https://t.me/BitbyteFinance',
        },
        image: 'https://pbs.twimg.com/profile_images/1486540118588792832/6oBnNTrW_400x400.jpg',
        paragraphs: [
            'Bitbyte is a multi-chain platform, mainly focused on providing Web3 builders and users with one-stop customized services.',
            'Including IDO, Airdrop, Mining Pools, Swap, NFT Market, Derivatives,etc.',
        ],
        chains: [ETHW],
    },
    {
        name: 'SafeMatrix Wallet',
        tags: [WALLET],
        description: "Safematrix is the world's first innovative combination of MPC, TEE and ZKP technologies to solve the problem of 'signature is power'.",
        links: {
            [WEBSITE]: 'https://safematrix.io/',
            [TWITTER]: 'https://twitter.com/Safematrix_io',
            [DISCORD]: 'https://discord.com/invite/4Ce4aHy2FQ',
            [GITHUB]: 'https://github.com/safematrix',
            [MEDIUM]: 'https://medium.com/@Safematrix',
        },
        image: 'https://pbs.twimg.com/profile_images/1474327657940615169/8Ww0uOGb_400x400.png',
        paragraphs: [
            "Safematrix is the world's first innovative combination of MPC, TEE and ZKP technologies to solve the problem of 'signature is power'.",
            "The team has deep knowledge in academic and extensive experience in engineering, with 14 papers in the field of privacy computing. They also have deep knowledge and experience in deploying complex crypto system to empower Web 3.0.",
            "Decentralized digital asset management platform Provide secure digital asset management services for DAO, Companies and Individuals",
        ],
        chains: [ETHW],
    },
    {
        name: 'SciencETHW',
        tags: [DEFI],
        description: "SciencEHTW aims to create an ecosystem where scientists are encouraged to openly share their researches and receive credit for their work while allowing anyone to access and contribute easily. We believe that scientific knowledge should be accessible to everyone and the process of scientific research should be transparent.",
        links: {
            [WEBSITE]: 'https://sciencethw.com/',
            [DAPP]: 'https://sciencethw.com/',
            [TWITTER]: 'https://twitter.com/_SciencEthw',
            [MEDIUM]: 'https://medium.com/@sciencethw',
            [TELEGRAM]: 'https://t.me/sciencethw',
            [GITHUB]: 'https://sciencethw.gitbook.io/wiki/',
        },
        image: 'https://i.postimg.cc/wMgQx0vZ/Disen-o-sin-ti-tulo-Science-ETHW.png',
        paragraphs: [
            "Our Mission",
            "Create value to scientific community",
            "Rewards scientific progress in a equal way",
            "Democratize the knowledge",
            "Boost scientific progress",
            "Be an investment opportunity",
        ],
        chains: [ETHW],
    },
    {
        name: 'Scry',
        tags: [INFRA],
        description: "We provide high scale, permissionless oracles for EVM networks.",
        links: {
            [WEBSITE]: 'https://scry.finance/',
            [DAPP]: 'https://app.scry.finance/',
            [TWITTER]: 'https://twitter.com/scryprotocol',
            [GITHUB]: 'https://GitHub.com/scryprotocol',
        },
        image: 'https://i.postimg.cc/SswfXNdb/Screenshot-20220917-171128-PR0-PR0.png',
        paragraphs: [
            "Scry is an open source, permissionless, flexible and robust framework for Oracle deployment with multifeed support, subscriptions and instant deployment. We have developed the Open Oracle Framework for high scale and flexible oracles.",
            "Open Oracle Framework’s a framework for permissionless oracle deployment and robust and flexible on-chain oracle feeds. Oracles are simply multi-party median value feeds, but you can even implement your own price logic through a dedicated proxy owner, which itself has it’s own price logic. The median value model takes the value for n signers, uses the median value submitted, makes sure that m signers for the m/n threshold has been met and returns the value. The oracle can require a small fee for subscriptions to feeds to cover gas fees, and are able to provide many feeds from 1 contract, allowing for highly efficient, scalable feed submission and retrieval.",
            "Flexibilty",
            "By allowing people to easily bootstrap feeds using multiple members, users can create decentralized oracle feeds for whatever they want, this is especially important for L2s where gas fees are low and so large signer sets and feeds can be created for realtime price sources. A simple node that queries many apis, submits them and then returns the med value on request allows for rapid and scalable deployment for Synthetic Assets, as anyone can just set up a node or set the feed to be sourced from a gnosis, letting the logic be based on an api or general agreement.",
            "Contract Many Feeds",
            "Oracles can have a single feed or have 1 contract and submit many feeds/prices available, allowing submitFeed(uint[] feedIDs, uint[] values) to save gas for large feed sets. This allows large players to easily submit multiple feeds with 1 call and not need to manage multiple transactions/calls to multiple contracts.",
            "Monetization and Incentives",
            "Because oracles have upkeep costs, the oracles can charge a small fee in ETH for subscriptions. This way they can deploy many feeds as long as they are worth the upkeep, and because we compact many feed updates into single calls, efficiency couldn’t be better. Users can then shop around for the best feed or can choose based on price, depending on risk tolerance. This creates an open oracle marketplace and revenue model and allows projects to quickly bootstrap feeds they need from providers. Oracles can then price their feeds based on upkeep and cost as well as deprecate unused feeds.",
            "Containerization",
            "Oracles are created as single contracts which are owned by the oracle parties that submit feeds, these oracles then create an id for every feed they want to create, which allows for users to explore feeds offered by an oracle and select based on id, while having each oracle be completely contained, such that bad oracles do not affect good oracles and users can choose providers that are good for them.",
            "Scalability",
            "OOF was designed for projects, users and providers to easily create new feeds and oracles for Ethereum and other networks to have access to offchain data in a decentralized and open market model. By allowing for anyone to create an oracle with minimal knowledge and time, and setting up decentralized providers that are robust, flexible and secure (with enough signers), feeds can rapidly scale and with them, the services that these networks provide can scale rapidly aswell.",
        ],
        chains: [ETHW],
    },
    {
        name: 'ShibPow',
        tags: [DEFI],
        description: "ShibPow is a deflationary coin launched on the ethereum pow chain. Each transaction reduces supply. ",
        links: {
            [WEBSITE]: 'https://shibpow.com/',
            [TWITTER]: 'https://twitter.com/ShibPow',
            [TELEGRAM]: 'https://t.me/Shibwpow',
        },
        image: 'https://i.postimg.cc/Y0V2ZQv5/IMG-20220923-175055-370-Alex.jpg',
        paragraphs: [
            "Great holder community Listed on UniWSwap",
        ],
        chains: [ETHW],
    },
    {
        name: 'Stithulf',
        tags: [DEFI],
        description: "Stithulf is a PoW Blockchain built on Substrate. The project is inspired by Bitcoins' Transaction & Security Functionalities.",
        links: {
            [WEBSITE]: 'https://stithulf.com/',
            [TWITTER]: 'https://twitter.com/StithulfCoin',
            [MEDIUM]: 'https://medium.com/@stithulfproject',
        },
        image: 'https://pbs.twimg.com/profile_images/1373687389109899265/URfvxiMr_400x400.jpg',
        paragraphs: [
            "The idea of building this blockchain came to me in the free time of COVID lockdowns. I started working on building the blockchain on 2020 and ran the first block on local computer in April 2022. Currently, the project is looking for options to public the blockchain.",
            "More details will be posted on Twitter @StithulfCoin",
        ],
        chains: [ETHW],
    },
    {
        name: 'SugarW',
        tags: [NFT, MARKETPLACES],
        description: "The most user-friendly and fastest NFT Marketplace on Ethereum PoW.",
        links: {
            [WEBSITE]: 'https://sugarw.io/',
            [DAPP]: 'https://sugarw.io/',
            [TWITTER]: 'https://twitter.com/SugarW_io',
            [DISCORD]: 'https://discord.gg/ggZJWmGW66',
            [TELEGRAM]: 'https://t.me/OfficiallSugarW',
        },
        image: 'https://i.postimg.cc/hjmg1mFG/Group-48096533-Support-Sugar-W.png',
        paragraphs: [
            "- The easiest and fastest to list NFT projects.",
            "- 24/7 full-stack support.",
            "- Has the most & the best potential projects.",
            "- Ideal for project promotion.",
        ],
        chains: [ETHW],
    },
    {
        name: 'TakiSwap',
        tags: [DEFI],
        description: "A decentralized exchange on the ETHPoW blockchain.",
        links: {
            [DAPP]: 'https://app.takiswap.org/#/swap',
            [TELEGRAM]: 'https://t.me/TakiSwap',
        },
        image: 'https://i.postimg.cc/yN0349gC/photo-2022-09-16-18-22-12-Taki.jpg',
        paragraphs: [
            "We are a small team who believe in the ETHPoW blockchain and ecosystem and want to provide the community with a simple familiar DEX to swap their tokens with.",
            "TakiSwap is a decentralized exchange utilizing the core Uniswap V2 smart contracts. Since ETHPoW is a fork of Ethereum before the merge, you will have the ability to swap out any tokens you owned before the merge event. Swap and provide liquidity just like you did on Uniswap V2 with our improved user interface.",
        ],
        chains: [ETHW],
    },
    {
        name: 'TLAND',
        tags: [NFT, METAVERSE, MARKETPLACES, DAPPS],
        description: "TLAND is a global multi-chain platform through which users from all over the world can participate in fundraisings to purchase the most desirable digital assets the crypto world has to offer!",
        links: {
            [WEBSITE]: 'https://tland.app/home',
            [TWITTER]: 'https://twitter.com/TLAND_Project',
            [DISCORD]: 'https://discord.gg/tland',
            [GITHUB]: 'https://github.com/tland-code',
            [MEDIUM]: 'https://medium.com/@terraland-io',
            [TELEGRAM]: 'https://t.me/terra_land',
        },
        image: 'https://pbs.twimg.com/profile_images/1448947091988942895/xJrVcuqw_400x400.png',
        paragraphs: [
            "Successfully started with real estate as the underlying asset, selling 4 properties in 4 months totalling $1 847 000 USD.",
            "We stress-tested our solution through the Terra crash, saving 100% of our investors' funds, while also earning them their income.",
            "Thanks to the gained experience and developed mechanisms and model of creating fractional ownership of real estate we are implementing the same core mechanisms in fractionalising ownership of digital assets such as NFT's and metaverses.",
            "Our mission is to facilitate the joint purchasing of any crypto assets through which users can own their share of the most exclusive digital goods/services that the blockchain world has created. Our investors can start fundraising events for anything, from limited edition NFTs to the most in-demand metaverse plots. Whether it is to be a Bored Ape owner, to take part in building the greatest metaverse to date, or to simply diversify an investment portfolio, our fractional sales platform is here to help you reach those goals together with your community.",
            "The idea is simple:",
            "1. vote",
            "2. join the prefund",
            "3. get your NFT fraction",
            "4. make decisions, utilise, and earn",
            "The main problem for the NFT world is the very high market entry barriers - this is due to the fact that exclusive and rare assets naturally have a very high price and are rarely liquid. Best-known assets often have utility, but because of their rarity (ie. price) only a few can afford them. The growing F-NFT market does not introduce usability for fractional tokens and the projects available on the market that try to find a solution often do not end up solving most of the problems. Lastly, the available solutions mainly operate on a single chain, which makes it even more difficult for users foreign to that ecosystem to benefit from them.",
            "TLAND, thanks to its previous experience, understands the needs of the market and has the technology to ensure that users will be able to fully utilise their F-NFTs - even though they will be co-owners of the underlying asset. TLAND provides the technology that will allow each co-owner to use all the utility of the NFT that they have collectively purchased. With proven technology, we are making it easier to break down the capital barrier to entry by enabling fractional ownership of assets as well as making it easier to access regardless of the chain the asset is located on. And last but not least, decentralisation - it is the community's decision on what to fractionalise.",
            "So, thanks to the gained experience, and developed mechanisms and model of creating fractional ownership of real estate we implemented the same core mechanisms for fractional ownership of digital assets such as NFTs and metaverses.",
            "We want to democratize speculation & money making on the most popular NFTs by allowing people to buy & sell fractional ownership.",
            "Our system offers:",
            "> fractional ownership buying & selling - giving profit from speculation",
            "> NFT renting - giving a stable income from the rental fees.",
            "We offer this functionality on multiple chains, to target more potential buyers & sellers, making speculation more profitable.",
        ],
        chains: [ETHW],
    },
    {
        name: 'Trustlook',
        tags: [SERVICES],
        description: "Smart Contract Audit Service.",
        links: {
            [WEBSITE]: 'https://www.trustlook.com/',
        },
        image: 'https://pbs.twimg.com/profile_images/598548506186387456/06aatpPF_400x400.png',
        isVerified: true,
        paragraphs: [
            "Our Smart Contract Audit service is able to help Web team avoid potentially costly errors with a multi-dimentional audit to your contracts. We combines AI engine with expert review to scrutinize the contract code and reveal any vulnerabilities . We verify the privileges of different roles to prevent abusement. We inspect the deployment server security to keep hackers away. We also monitor abnormal activities on chain so you and your customers can rest assured.",
        ],
        chains: [ETHW],
    },
    {
        name: 'TWIT',
        tags: [NFT, INFRA],
        description: "Twit is the Web3 version of Twitter. Twitter is the Web2 version of Twit.",
        links: {
            [WEBSITE]: 'https://twit.domains/',
            [TWITTER]: 'https://twitter.com/TwitNameService',
            [DISCORD]: 'https://discord.gg/8jdCsNYgrQ',
        },
        image: 'https://i.postimg.cc/t4hPbV01/TWITLOGO-vicky-wei.jpg',
        isVerified: true,
        paragraphs: [
            "Twit and Twitter are two sides of the same coin and complement each other.",
            "Twit is not only information interaction, but also a Web3 living space of multi-dimensional experience. The .twit domain name will become the common ID for Web3 to break the circle and cross-chain.",
            "Twit reserves the same .twit domain name as the username for each Twitter user. For example, @elonmusk can claim the elonmusk.twit domain name for free.",
        ],
        chains: [ETHW],
    },
    {
        name: 'UniW Pad',
        tags: [LAUNCHPAD],
        description: "UniW Pad is the native launchpad of UniWswap, supported by the UniWgrant Accelerator Program.",
        links: {
            [WEBSITE]: 'https://farm.uniwswap.com/launchpad',
            [DAPP]: 'https://farm.uniwswap.com/launchpad',
            [TWITTER]: 'https://twitter.com/uniwswap',
            [MEDIUM]: 'https://medium.com/@uniwswap',
            [TELEGRAM]: 'https://t.me/uniwswap',
        },
        image: 'https://i.postimg.cc/PJFHCy9h/LLogo-Uni-W-Swap.jpg',
        paragraphs: [
            "Uniw Pad is the native Launchpad of UniWswap, the leading DEX on Ethereum PoW. This is the place where you can discover new high quality projects that have been verified by the Uniw team, with the goal of improving the output quality of projects joining the chain. Put your UniW and UniW Punks to work in order to discover new opportunities and expand the Ethereum PoW Chain.",
            "Joining the Launchpads is easy. Simply commit your desired amount of UNIW, and at the end of the Launchpad you will be able to claim your new tokens. The amount of tokens you receive will be based on the weight your assets have in the launchpad. If you would like to further increase your maximum allocation you can use your UniW Punks to receive a boost of up to 100% in allocation, based on the rarity of your Punk.",
            "UniW Pad features the Overflow Launchpad method, allowing more users to join a hardcap, therefore allowing a smoother launch of projects, with less whales that can create damaging volatility.",
            "The goal of UniW Pad is to accelerate the adoption of ETHW by bringing brand new services, developed by KYC and Audited teams, that will incentivise users to move from other chains to ETHW.",
        ],
        chains: [ETHW],
    },
    {
        name: 'UniW Punks',
        tags: [NFT, NATIVE_NFT],
        description: "UniW Punks is the first NFT collection released by the biggest ecosystem on Ethereum PoW, UniWswap. They are a collection of 1000 unique unicorns with various rarities tiers and traits, stakeable on UniWswap.",
        links: {
            [WEBSITE]: 'https://uniwpunks.com/',
            [DAPP]: 'https://uniwpunks.com/',
            [TWITTER]: 'https://twitter.com/uniwswap',
            [MEDIUM]: 'https://medium.com/@uniwswap',
            [TELEGRAM]: 'https://t.me/uniwswap',
        },
        image: 'https://i.postimg.cc/0j7bNQ9z/Uni-W-Punks-Uni-W-Swap.png',
        paragraphs: [
            "UNIW Punks is the official collection of the UniWswap ecosystem, the leading DEX & AMM on the EthereumPow Blockchain.",
            "The collection consists of 1000 unique NFTs with various rarity tiers, exclusive backgrounds and fun traits. Besides being fun artworks, UNIW Punks also have high utility in the UniW Ecosystem, through NFT Staking in Farms and Launchpads.",
            "In UniW Farms, the NFTs can give you anywhere from 1% up to 10% farming boost, highly optimizing your farming experience.",
            "In UniW Pad, the NFTs can allow you to increase your Max Allowance in the launchpad from 10% up to 100%, allowing you to get a bigger piece of the pie during our launches.",
            "They are currently tradeable on all of the major ETHW NFT Marketplace, and they will soon be tradeable at home, on UniWswap's Native NFT Marketplace.",
        ],
        chains: [ETHW],
    },
    {
        name: 'UniWswap',
        tags: [EXCHANGES, DEFI, NFT],
        description: "UniWswap is the #1 DEX Ecosystem on Ethereum PoW, boasting high liquidity, low trading fees and deflationary token emission through burn mechanisms.",
        links: {
            [WEBSITE]: 'https://uniwswap.com/',
            [DAPP]: 'https://app.uniwswap.com/#/swap',
            [TWITTER]: 'https://twitter.com/uniwswap',
            [MEDIUM]: 'https://medium.com/@uniwswap',
            [TELEGRAM]: 'https://t.me/uniwswap',
        },
        image: 'https://i.postimg.cc/PJFHCy9h/LLogo-Uni-W-Swap.jpg',
        paragraphs: [
            "UniWswap is the most advanced Decentralized Exchange on the newly founded Ethereum PoW Chain, striving for true decentralization of the blockchain. The DEX boasts a brand new interface designed in house by the team, and plenty of original features to improve the userbase's experience and aid tokenomics.",
            "- Total Supply 50,000,000 UNIW",
            "- Highest DEX Liquidity on Chain",
            "- AMM (Only 0.17% Trading Fees)",
            "- Farm",
            " - Burning Mechanism (3% Sell Tax for UNIW Burns)",
            "- Referral System (Earn 1% in Extra Minted Rewards Based on each Referred User's Staked Amount)",
            "- NFTw (NFT Staking Coming Soon)",
            "- NFT Marketplace (Coming Soon)",
            "- ETHW pool distribution (Coming Soon)",
            "- Launchpad (Coming Soon)",
            "- wUSDTw Bridge (Coming Soon)",
            "- Mini Games (Coming Soon)",
        ],
        chains: [ETHW],
    },
    {
        name: 'USDW Stablecoin',
        tags: [INFRA, DEFI, LENDING, STABLECOINS],
        description: "Fully decentralised and censorship resistant stablecoin based on liquity protocol codes.",
        links: {
            [WEBSITE]: 'https://www.realprotocol.xyz/',
            [DAPP]: 'https://lend.puffydao.com/#/',
            [TWITTER]: 'https://twitter.com/realprotocoleth',
            [DISCORD]: 'https://discord.gg/PKryypuvmy',
            [GITHUB]: 'https://github.com/Real-protocol/Real-usdw',
            [TELEGRAM]: 'https://t.me/realprotocolgroup',
        },
        isVerified: true,
        image: 'https://i.postimg.cc/02ZvvtjR/real-protocol-500x500.png',
        paragraphs: [
            "Deposit ETHW and borrow the first native usd pegged stablecoin on ethw ecosystem, with 0% interest borrowing and a 110% collateral ratio.",
        ],
        chains: [ETHW],
    },
    {
        name: 'Virgo',
        tags: [WALLET],
        description: "The all-in-one decentralized wallet.",
        links: {
            [WEBSITE]: 'https://virgo.net/',
            [DAPP]: 'https://chrome.google.com/webstore/detail/virgo-wallet/ibljocddagjghmlpgihahamcghfggcjc?hl=fr&authuser=0',
            [TWITTER]: 'https://twitter.com/virgo_coin',
            [DISCORD]: 'https://discord.com/invite/mSqDRzvBug',
            [GITHUB]: 'https://github.com/virgoproject',
            [MEDIUM]: 'https://medium.com/@virgocoin',
            [TELEGRAM]: 'https://t.me/virgoCommunity',
        },
        image: 'https://pbs.twimg.com/profile_images/1541804913860165634/Icd2fv2j_400x400.jpg',
        paragraphs: [
            "An easy-to-use, cross-chain wallet in your browser!",
            "Virgo Wallet is an all-in-one decentralized cryptocurrency wallet that allows users to store and trade securely popular digital assets directly with each other. It currently supports nine blockchains, including Ethereum, the Binance Smart Chain, Polygon, Avalanche, Fantom, Huobi Heco Chain, Chronos Chain, and more.",
            "Regarding assets exchange, Virgo Wallet will soon use atomic swaps technology to handle direct transactions across blockchains. The browser extension will quickly implement a DApps Store, giving you even more power. Search, discover, and download your favorite applications without leaving the wallet.",
            "The Wallet is Web3-enabled. This feature, often overlooked by other wallets, allows you to interact directly with websites like Uniswap to make your life easier and save time. This browser extension is not susceptible to hacks, as users are the only people who have and can access their funds.",
            "- Best cryptocurrency wallet extension to securely store private keys on your web browser",
            "- Store and manage your assets, view your favorite tokens latest news",
            "- Cross-chain Wallet directly with other users (soon)",
            "- Send, Receive, Buy and Sell your assets within Virgo Wallet",
            "- Check your wallet balance, transaction history, and other details about your wallet",
            "- Keep your private key safe with bank-level security",
            "- Keep your data safe; we don't collect any personal information",
        ],
        chains: [ETHW],
    },
    {
        name: 'Wafe Box',
        tags: [INFRA],
        description: "Wafebox is the first multi-signature wallet and the most trusted platform to manage digital assets on EthereumPoW.",
        links: {
            [WEBSITE]: 'https://wafebox.com/',
            [TWITTER]: 'http://twitter.com/wafebox',
            [DISCORD]: 'http://discord.gg/AUN9MDmNXY',
        },
        isVerified: false,
        image: 'https://pbs.twimg.com/profile_images/1580613311468445697/nrBu5uPd_400x400.jpg',
        chains: [ETHW],
    },
    {
        name: 'WENS | ETHW Name Service',
        tags: [INFRA],
        description: "Decentralised naming for the ETHW ecosystem and beyond.",
        links: {
            [WEBSITE]: 'https://wens.domains/',
            [DAPP]: 'https://app.wens.domains/',
            [TWITTER]: 'https://twitter.com/wensdomains',
            [DISCORD]: 'https://discord.gg/wens',
            [GITHUB]: 'https://github.com/ethwens',
        },
        isVerified: true,
        image: 'https://i.postimg.cc/vBW0jmpr/IMG-9849-Wagmi33-Foundation.png',
        paragraphs: [
            "EthereumPoW Name Service (WENS) is a naming protocol that allows humans to use easy-to-remember domain names for their cryptocurrency addresses. The protocol then translates it to a machine-readable address.",
            "WENS has a plethora of innovations on top of ENS in order to truly enable web3 experience. WENS supports personalized top level domains in addition to standard .ethw names. WENS is purely onchain, i.e., not relying on IPFS or other off-chain storage solutions.",
        ],
        chains: [ETHW],
    },
    {
        name: 'XEN',
        tags: [MEMECOINS],
        description: "XEN aims to become a community building crypto asset that connects like minded people together. If you are a seasoned OG or simply Crypto curious, XEN has the lowest barrier to entry through its unique tokenomics.",
        links: {
            [WEBSITE]: 'https://xen.network/',
            [DAPP]: 'https://xen.network/mainnet/mint',
            [TWITTER]: 'https://twitter.com/mrjacklevin',
            [GITHUB]: 'https://github.com/FairCrypto/XEN-crypto',
            [DISCORD]: 'https://discord.com/invite/rcAhrKWJb6',
            // [REDDIT]: 'https://www.reddit.com/r/xencrypto/',
            // [YOUTUBE]: 'https://m.youtube.com/channel/UCiw5nyHHt9BPHvoRbcGNehA/playlists',
            [TELEGRAM]: 'https://t.me/XENCryptoTalk',
        },
        isVerified: true,
        image: 'https://i.postimg.cc/yN8ShZRp/9-F05-Guhn-400x400.jpg',
        // paragraphs: [
        //     "YorkieDoge New memes token aiming to build a large community on EthereumPoW.",
        // ],
        chains: [ETHW],
    },
    {
        name: 'Yayasea',
        tags: [NFT, MARKETPLACES, LAUNCHPAD],
        description: "Yayasea, the NFT marketplace and launchpad to make you feel at home on EthereumPoW. LOWEST FEES!",
        links: {
            [WEBSITE]: 'https://yayasea.com/',
            [DAPP]: 'https://yayasea.com/',
            [TWITTER]: 'https://twitter.com/yaya_sea',
            [DISCORD]: 'https://discord.com/invite/KbYbMuyCDK',
            [TELEGRAM]: 'https://t.me/yorkiedoge',
        },
        image: 'https://i.postimg.cc/jSZhxnzw/yys-Ge-Yang.jpg',
        isVerified: false,
        chains: [ETHW],
        paragraphs: [
            "Most advanced and user-friendly features, and lowest fees across all NFT marketplaces. Best NFT launchpad.",
        ],
    },
    {
        name: 'YorkieDoge',
        tags: [NFT, NATIVE_NFT],
        description: "YorkieDoge is Memes Token base on community power on EthereumPoW.",
        links: {
            [WEBSITE]: 'https://yorkiedoge.dog',
            [TWITTER]: 'https://twitter.com/DogeYorkie',
            [TELEGRAM]: 'https://t.me/yorkiedoge',
        },
        image: 'https://i.postimg.cc/Fs80PqvT/logo-yorkie-doge.png',
        chains: [ETHW],
    },
    {
        name: 'zergswap',
        tags: [DEFI, EXCHANGES],
        description: "Zergswap is the 1st open-source and audited AMM-based decentralized crypto trading protocol on EthereumPoW.",
        links: {
            [WEBSITE]: 'https://zergswap.com',
            [DAPP]: 'https://zergswap.com/#/swap',
            [TWITTER]: 'https://twitter.com/zergswap',
            [DISCORD]: 'https://discord.gg/ghBAzStAjX',
            // [TELEGRAM]: 'https://t.me/yorkiedoge',
        },
        image: 'https://i.postimg.cc/nrbSx0gQ/80-AB3-EC1-468-A-47-E3-8182-1-D85-EEC030-EA-Beatles-AWSB.jpg',
        chains: [ETHW],
    },
];

export default DATA;
